<template>
  <div class="user_wrap">
    <div class="top_header">
      <div class="user_detail">
        <div class="service">
          <!-- <div class="logo">
            <img src="../../assets/images/logo/logo.png" />
          </div> -->
          <div />
          <div style="display: flex">
            <div
              class="service_title"
              @click="$router.push('/support')"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_6581_88442)">
                  <path
                    d="M18.819 35.0067C18.3065 35.0123 17.8029 34.8731 17.3661 34.605C16.9293 34.337 16.5771 33.9511 16.35 33.4917H13.95C12.7486 33.5191 11.5853 33.0692 10.715 32.2405C9.84474 31.4118 9.33841 30.272 9.30697 29.0707V28.3357H8.86797C8.50608 28.3451 8.15528 28.2104 7.89273 27.9611C7.63019 27.7119 7.47739 27.3686 7.46797 27.0067V16.8697C7.46797 16.8537 7.47897 16.8427 7.48697 16.8297C7.63708 13.6221 9.02379 10.5973 11.3561 8.3901C13.6884 6.18291 16.785 4.96491 19.996 4.99169C23.2075 4.96358 26.3051 6.18074 28.6384 8.38764C30.9717 10.5945 32.3593 13.6196 32.51 16.8277C32.5203 16.8395 32.5269 16.8541 32.529 16.8697V27.0007C32.5246 27.18 32.4848 27.3566 32.412 27.5205C32.3392 27.6844 32.2348 27.8323 32.1048 27.9557C31.9747 28.0792 31.8216 28.1758 31.6541 28.2399C31.4867 28.3041 31.3082 28.3346 31.129 28.3297H26.568C26.2068 28.3383 25.857 28.2031 25.5954 27.9539C25.3338 27.7047 25.1819 27.3619 25.173 27.0007V18.1107C25.1816 17.7493 25.3334 17.4062 25.595 17.1568C25.8567 16.9074 26.2066 16.7721 26.568 16.7807H29.146C29.0121 14.4445 27.9898 12.2481 26.2886 10.6415C24.5873 9.03486 22.3359 8.13983 19.996 8.13983C17.656 8.13983 15.4046 9.03486 13.7034 10.6415C12.0021 12.2481 10.9798 14.4445 10.846 16.7807H13.424C13.6032 16.7758 13.7817 16.8063 13.9491 16.8704C14.1166 16.9346 14.2697 17.0312 14.3998 17.1546C14.5298 17.2781 14.6342 17.426 14.707 17.5899C14.7798 17.7538 14.8196 17.9304 14.824 18.1097V26.9997C14.8196 27.179 14.7798 27.3556 14.707 27.5195C14.6342 27.6834 14.5298 27.8313 14.3998 27.9547C14.2697 28.0782 14.1166 28.1748 13.9491 28.2389C13.7817 28.3031 13.6032 28.3336 13.424 28.3287H11.547V29.0687C11.5635 29.6911 11.8259 30.2817 12.2769 30.7111C12.7278 31.1404 13.3305 31.3737 13.953 31.3597H16.335C16.5602 30.8935 16.9135 30.501 17.3536 30.2281C17.7936 29.9553 18.3022 29.8132 18.82 29.8187H21.184C21.5331 29.805 21.8813 29.8619 22.2079 29.986C22.5344 30.1102 22.8326 30.2989 23.0844 30.5411C23.3362 30.7832 23.5366 31.0737 23.6734 31.3951C23.8103 31.7166 23.8808 32.0623 23.8808 32.4117C23.8808 32.761 23.8103 33.1068 23.6734 33.4282C23.5366 33.7497 23.3362 34.0402 23.0844 34.2823C22.8326 34.5244 22.5344 34.7132 22.2079 34.8374C21.8813 34.9615 21.5331 35.0184 21.184 35.0047L18.819 35.0067ZM34.307 25.5837V19.5257C34.3079 19.4517 34.325 19.3789 34.3571 19.3122C34.3891 19.2456 34.4353 19.1867 34.4924 19.1398C34.5496 19.0928 34.6163 19.0589 34.6879 19.0404C34.7595 19.0219 34.8342 19.0193 34.907 19.0327C35.5769 19.1482 36.1856 19.4935 36.6283 20.0093C37.0711 20.5251 37.3203 21.179 37.333 21.8587V23.2497C37.3203 23.9293 37.0711 24.5833 36.6283 25.0991C36.1856 25.6149 35.5769 25.9602 34.907 26.0757C34.874 26.082 34.8405 26.0851 34.807 26.0847C34.6741 26.0837 34.5469 26.0309 34.4524 25.9375C34.3579 25.8441 34.3036 25.7175 34.301 25.5847L34.307 25.5837ZM5.09197 26.0767C4.42244 25.9608 3.8142 25.6153 3.37182 25.0995C2.92944 24.5838 2.68056 23.9301 2.66797 23.2507V21.8607C2.68042 21.1809 2.92948 20.5266 3.37228 20.0107C3.81508 19.4947 4.42391 19.1492 5.09397 19.0337C5.1667 19.0203 5.24147 19.0229 5.31308 19.0414C5.38468 19.0599 5.45138 19.0938 5.50851 19.1408C5.56565 19.1877 5.61185 19.2466 5.64388 19.3132C5.67592 19.3799 5.69301 19.4527 5.69397 19.5267V25.5847C5.69336 25.6587 5.67649 25.7318 5.64457 25.7986C5.61265 25.8654 5.56644 25.9244 5.50922 25.9715C5.452 26.0185 5.38515 26.0524 5.3134 26.0707C5.24165 26.0891 5.16674 26.0914 5.09397 26.0777L5.09197 26.0767Z"
                    fill=""
                  />
                </g>
                <defs>
                  <clipPath id="clip0_6581_88442">
                    <rect
                      width="40"
                      height="40"
                      fill=""
                    />
                  </clipPath>
                </defs>
              </svg>
              <div class="svg_title">
                Suporte
              </div>
            </div>
            <div
              class="service_title"
              @click="toSupport(2)"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_6581_88447)">
                  <path
                    d="M20.0009 35.3339C16.968 35.3343 14.0032 34.4352 11.4814 32.7504C8.95951 31.0656 6.99395 28.6708 5.83328 25.8688C4.67261 23.0669 4.36896 19.9836 4.96074 17.0091C5.55253 14.0345 7.01315 11.3023 9.15789 9.15789C11.3023 7.01315 14.0345 5.55253 17.0091 4.96074C19.9836 4.36896 23.0669 4.67261 25.8688 5.83328C28.6708 6.99395 31.0656 8.95951 32.7504 11.4814C34.4352 14.0032 35.3343 16.968 35.3339 20.0009C35.3445 23.3554 34.2447 26.619 32.2059 29.2829C32.8979 30.3119 33.9599 32.2209 33.2979 33.4269C33.1709 33.6357 32.9872 33.804 32.7682 33.9124C32.5492 34.0207 32.3039 34.0646 32.0609 34.0389C30.7851 33.8871 29.5572 33.4618 28.4609 32.7919C25.9531 34.4546 23.0098 35.339 20.0009 35.3339ZM27.8939 17.3339C27.348 17.3339 26.8144 17.4958 26.3605 17.799C25.9066 18.1023 25.5529 18.5334 25.344 19.0377C25.1351 19.542 25.0804 20.0969 25.1869 20.6323C25.2934 21.1677 25.5563 21.6595 25.9423 22.0455C26.3283 22.4315 26.82 22.6944 27.3554 22.8009C27.8908 22.9073 28.4458 22.8527 28.9501 22.6438C29.4544 22.4349 29.8855 22.0811 30.1887 21.6273C30.492 21.1734 30.6539 20.6398 30.6539 20.0939C30.6531 19.3621 30.3621 18.6606 29.8446 18.1431C29.3272 17.6257 28.6256 17.3347 27.8939 17.3339ZM20.0009 17.3339C19.455 17.3339 18.9214 17.4958 18.4675 17.799C18.0136 18.1023 17.6599 18.5334 17.451 19.0377C17.2421 19.542 17.1874 20.0969 17.2939 20.6323C17.4004 21.1677 17.6633 21.6595 18.0493 22.0455C18.4353 22.4315 18.927 22.6944 19.4624 22.8009C19.9978 22.9073 20.5528 22.8527 21.0571 22.6438C21.5614 22.4349 21.9925 22.0811 22.2957 21.6273C22.599 21.1734 22.7609 20.6398 22.7609 20.0939C22.7601 19.3621 22.4691 18.6606 21.9516 18.1431C21.4342 17.6257 20.7326 17.3347 20.0009 17.3339ZM12.0939 17.3339C11.548 17.3339 11.0144 17.4958 10.5605 17.799C10.1066 18.1023 9.75288 18.5334 9.54398 19.0377C9.33508 19.542 9.28042 20.0969 9.38692 20.6323C9.49341 21.1677 9.75628 21.6595 10.1423 22.0455C10.5283 22.4315 11.02 22.6944 11.5554 22.8009C12.0908 22.9073 12.6458 22.8527 13.1501 22.6438C13.6544 22.4349 14.0855 22.0811 14.3887 21.6273C14.692 21.1734 14.8539 20.6398 14.8539 20.0939C14.8531 19.3621 14.5621 18.6606 14.0446 18.1431C13.5272 17.6257 12.8256 17.3347 12.0939 17.3339Z"
                    fill=""
                  />
                </g>
                <defs>
                  <clipPath id="clip0_6581_88447">
                    <rect
                      width="40"
                      height="40"
                      fill=""
                    />
                  </clipPath>
                </defs>
              </svg>
              <div class="svg_title">
                Mensagens
              </div>
            </div>
            <div
              class="service_title"
              @click="$router.push('/setting')"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_6581_88452)">
                  <path
                    d="M25.1417 35.2944C24.399 35.0207 23.7042 34.6316 23.0827 34.1414C22.9969 34.0741 22.9253 33.9903 22.8723 33.895C22.8192 33.7997 22.7857 33.6948 22.7737 33.5864C22.7617 33.4797 22.7711 33.3717 22.8013 33.2687C22.8315 33.1657 22.882 33.0697 22.9497 32.9864C23.1621 32.7278 23.2893 32.4099 23.3139 32.0761C23.3384 31.7424 23.259 31.4092 23.0867 31.1224C22.9328 30.8683 22.7159 30.6584 22.4569 30.5129C22.1979 30.3675 21.9057 30.2915 21.6087 30.2924C21.525 30.2924 21.4415 30.2984 21.3587 30.3104C21.318 30.3164 21.2768 30.3194 21.2357 30.3194C21.036 30.3195 20.8425 30.2495 20.6892 30.1216C20.5358 29.9936 20.4323 29.8159 20.3967 29.6194C20.27 28.8539 20.27 28.0729 20.3967 27.3074C20.4302 27.1099 20.5332 26.9309 20.687 26.8026C20.8408 26.6743 21.0354 26.605 21.2357 26.6074C21.2765 26.6071 21.3173 26.6098 21.3577 26.6154C21.4372 26.6261 21.5174 26.6315 21.5977 26.6314C21.8985 26.6317 22.1943 26.5546 22.4567 26.4074C22.6667 26.2904 22.8489 26.1292 22.9906 25.935C23.1324 25.7408 23.2303 25.5181 23.2777 25.2824C23.3239 25.0479 23.3179 24.8061 23.2602 24.5742C23.2024 24.3423 23.0944 24.1259 22.9437 23.9404C22.8063 23.7722 22.7412 23.5565 22.7627 23.3404C22.7744 23.2316 22.8077 23.1263 22.8608 23.0306C22.9139 22.935 22.9856 22.8509 23.0717 22.7834C23.691 22.2948 24.3822 21.9049 25.1207 21.6274C25.2189 21.5906 25.3228 21.5717 25.4277 21.5714C25.5981 21.5691 25.7653 21.6177 25.9078 21.7111C26.0503 21.8045 26.1617 21.9383 26.2277 22.0954C26.3575 22.4062 26.5771 22.6712 26.8584 22.8565C27.1397 23.0418 27.4699 23.1389 27.8067 23.1354H27.8127C28.1515 23.1385 28.4835 23.0403 28.7661 22.8534C29.0487 22.6665 29.269 22.3994 29.3987 22.0864C29.4636 21.9304 29.5738 21.7973 29.7149 21.7043C29.856 21.6113 30.0217 21.5626 30.1907 21.5644C30.293 21.5643 30.3946 21.5823 30.4907 21.6174C31.2336 21.8907 31.9289 22.2795 32.5507 22.7694C32.637 22.8364 32.7091 22.92 32.7625 23.0153C32.8159 23.1107 32.8496 23.2158 32.8617 23.3244C32.8737 23.4311 32.8643 23.5391 32.8341 23.6421C32.8039 23.7451 32.7534 23.8411 32.6857 23.9244C32.4718 24.1823 32.3437 24.5005 32.3193 24.8346C32.2949 25.1688 32.3755 25.5022 32.5497 25.7884V25.7964C32.7026 26.0508 32.9189 26.2612 33.1774 26.407C33.4359 26.5529 33.7279 26.6291 34.0247 26.6284C34.109 26.6284 34.1932 26.6224 34.2767 26.6104C34.3174 26.6044 34.3585 26.6014 34.3997 26.6014C34.5995 26.6008 34.7931 26.6707 34.9466 26.7987C35.1 26.9267 35.2034 27.1047 35.2387 27.3014C35.3653 28.0665 35.3653 28.8473 35.2387 29.6124C35.2206 29.7203 35.1811 29.8235 35.1226 29.9159C35.064 30.0083 34.9875 30.088 34.8977 30.1504C34.7518 30.2547 34.577 30.3106 34.3977 30.3104C34.3562 30.3105 34.3148 30.3078 34.2737 30.3024C34.1928 30.291 34.1113 30.2853 34.0297 30.2854C33.7325 30.2845 33.4402 30.361 33.1815 30.5074C32.9229 30.6538 32.7068 30.8651 32.5547 31.1204C32.3831 31.406 32.3041 31.7377 32.3285 32.07C32.3528 32.4022 32.4793 32.7188 32.6907 32.9764C32.7587 33.0596 32.8095 33.1555 32.8403 33.2585C32.871 33.3615 32.881 33.4695 32.8697 33.5764C32.8575 33.6858 32.8236 33.7916 32.7698 33.8876C32.716 33.9836 32.6436 34.0679 32.5567 34.1354C31.9386 34.6225 31.2488 35.0108 30.5117 35.2864C30.4134 35.3228 30.3095 35.3414 30.2047 35.3414C30.0344 35.3441 29.8671 35.2957 29.7246 35.2025C29.582 35.1093 29.4706 34.9755 29.4047 34.8184C29.274 34.507 29.0535 34.2416 28.7714 34.0561C28.4893 33.8705 28.1583 33.7731 27.8207 33.7764C27.4825 33.7729 27.1509 33.8704 26.8683 34.0563C26.5858 34.2423 26.3652 34.5083 26.2347 34.8204C26.1508 35.0239 25.9903 35.1863 25.7877 35.2724C25.6784 35.3208 25.5602 35.3456 25.4407 35.3454C25.3388 35.3464 25.2375 35.3291 25.1417 35.2944ZM24.6857 28.4564C24.6867 29.2867 25.0171 30.0828 25.6042 30.6699C26.1913 31.257 26.9873 31.5873 27.8177 31.5884C28.648 31.5873 29.444 31.257 30.0312 30.6699C30.6183 30.0828 30.9486 29.2867 30.9497 28.4564C30.9486 27.6261 30.6183 26.8302 30.0311 26.2433C29.4439 25.6563 28.6479 25.3262 27.8177 25.3254C26.9883 25.3262 26.193 25.6556 25.606 26.2415C25.019 26.8274 24.6881 27.622 24.6857 28.4514V28.4564ZM9.11368 34.1814C6.20468 33.3344 4.66668 32.1194 4.66668 30.6644C4.60608 29.146 4.96858 27.6407 5.71375 26.3163C6.45891 24.992 7.55742 23.9007 8.88668 23.1644C10.3105 22.3554 11.8573 21.7855 13.4657 21.4774C15.3121 21.1109 17.1913 20.9343 19.0737 20.9504C19.9507 20.9504 20.8137 20.9874 21.6387 21.0604C20.4707 21.9563 19.5254 23.1098 18.8764 24.431C18.2273 25.7522 17.892 27.2054 17.8967 28.6774C17.8921 31.1499 18.8438 33.5284 20.5527 35.3154C20.0027 35.3334 19.4527 35.3414 18.9257 35.3414C15.6181 35.3976 12.317 35.0074 9.11368 34.1814ZM14.2937 16.9484C13.6226 16.2812 13.0906 15.4875 12.7284 14.6133C12.3662 13.7391 12.1811 12.8017 12.1837 11.8554C12.1811 10.9091 12.3663 9.97175 12.7285 9.09753C13.0907 8.22331 13.6227 7.4296 14.2937 6.76239C14.9609 6.09103 15.7547 5.55876 16.6291 5.19639C17.5035 4.83403 18.4412 4.64878 19.3877 4.65139C20.334 4.64884 21.2713 4.83401 22.1456 5.19619C23.0198 5.55838 23.8135 6.09038 24.4807 6.76139C25.1517 7.42861 25.6837 8.2223 26.0459 9.09652C26.4081 9.97074 26.5932 10.9081 26.5907 11.8544C26.5933 12.8007 26.4081 13.7381 26.046 14.6123C25.6838 15.4865 25.1517 16.2802 24.4807 16.9474C23.8135 17.6184 23.0198 18.1504 22.1456 18.5126C21.2713 18.8748 20.334 19.06 19.3877 19.0574C18.4415 19.0607 17.5041 18.8762 16.6297 18.5147C15.7553 18.1532 14.9613 17.6219 14.2937 16.9514V16.9484Z"
                    fill=""
                  />
                </g>
                <defs>
                  <clipPath id="clip0_6581_88452">
                    <rect
                      width="40"
                      height="40"
                      fill=""
                    />
                  </clipPath>
                </defs>
              </svg>
              <div class="svg_title">
                Dados
              </div>
            </div>
          </div>
        </div>
        <div class="user_flex">
          <img
            src="../../assets/images/person/avt.png"
            class="avt_img"
            alt=""
          >

          <div class="user_right">
            <div class="user_name">
              <div>
                <div class="user_nickname">
                  <span class="vip_name">Conta:</span>
                  <span>{{ data.nickname }}</span>
                  <!-- <img @click="$router.push('/edit')" src="../../assets/images/person/edit2.png"
                  style="width:0.4rem;margin-left:10px" alt=""> -->
                </div>
                <div class="user_clear">
                  <div class="user_vip">
                    <span class="vip_name">ID:</span>
                    <span>{{ data.id }}</span>
                    <div
                      class="svg_div"
                      @click="doCopy(data.id)"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="13"
                        viewBox="0 0 26 26"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_2451_66251)">
                          <g clip-path="url(#clip1_2451_66251)">
                            <path
                              d="M10.1064 5.85938H20.5844C21.7549 5.8607 22.8771 6.32627 23.7048 7.15396C24.5325 7.98165 24.9981 9.10385 24.9994 10.2744V20.7524C24.9981 21.9229 24.5325 23.0451 23.7048 23.8728C22.8771 24.7005 21.7549 25.1661 20.5844 25.1674H10.1064C8.93588 25.1661 7.81368 24.7005 6.98599 23.8728C6.15831 23.0451 5.69273 21.9229 5.69141 20.7524V10.2744C5.69273 9.10385 6.15831 7.98165 6.98599 7.15396C7.81368 6.32627 8.93588 5.8607 10.1064 5.85938ZM20.5844 22.7164C21.1052 22.7161 21.6046 22.5091 21.9729 22.1408C22.3411 21.7726 22.5481 21.2732 22.5484 20.7524V10.2744C22.5466 9.75461 22.3388 9.25675 21.9708 8.88979C21.6027 8.52282 21.1042 8.31664 20.5844 8.31637H10.1064C9.58768 8.31822 9.09073 8.5251 8.72393 8.8919C8.35713 9.25869 8.15025 9.75565 8.14841 10.2744V20.7524C8.14867 21.2721 8.35485 21.7706 8.72182 22.1387C9.08878 22.5068 9.58664 22.7145 10.1064 22.7164H20.5844Z"
                              fill="currentColor"
                            />
                            <path
                              d="M3.46995 20.87C3.29252 20.8705 3.11713 20.8323 2.95599 20.758C2.79485 20.6837 2.65185 20.5752 2.53695 20.44C1.54592 19.2806 1.00156 17.8053 1.00195 16.28V7.406C1.00381 5.70794 1.67904 4.07993 2.87957 2.87903C4.08009 1.67813 5.70789 1.00238 7.40595 1H16.284C17.1489 0.999689 18.005 1.17472 18.8004 1.51452C19.5959 1.85431 20.3142 2.35183 20.912 2.977C21.1245 3.2141 21.2364 3.52458 21.2241 3.84275C21.2118 4.16092 21.0762 4.46182 20.846 4.68178C20.6157 4.90174 20.309 5.0235 19.9906 5.0213C19.6722 5.0191 19.3671 4.89312 19.14 4.67C18.7721 4.28252 18.3289 3.97433 17.8376 3.76436C17.3463 3.55439 16.8172 3.44708 16.283 3.449H7.40595C6.35726 3.45059 5.35201 3.86809 4.61075 4.60992C3.86949 5.35174 3.45275 6.3573 3.45195 7.406V16.284C3.45168 17.2247 3.78713 18.1346 4.39795 18.85C4.54919 19.0279 4.64647 19.2453 4.67834 19.4767C4.71021 19.708 4.67536 19.9436 4.57787 20.1558C4.48039 20.368 4.32433 20.548 4.12806 20.6745C3.93179 20.801 3.70347 20.8688 3.46995 20.87Z"
                              fill="currentColor"
                            />
                          </g>
                        </g>
                        <defs>
                          <clipPath id="clip0_2451_66251">
                            <rect
                              width="26"
                              height="26"
                              fill="currentColor"
                            />
                          </clipPath>
                          <clipPath id="clip1_2451_66251">
                            <rect
                              width="26"
                              height="26"
                              fill="currentColor"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <!-- <img
                      @click="doCopy(data.id)"
                      src="../../assets/images/person/copy.png"
                      alt=""
                    /> -->
                  </div>
                  <div class="user_yue">
                    <img src="../../assets/images/person/a04.png">
                    <span>{{ data.money }}</span>
                    <div
                      style="margin-left: 0.2rem; margin-top: 0.1rem"
                      @click="getUserInfoPerson()"
                    >
                      <svg
                        width="14"
                        height="15"
                        viewBox="0 0 14 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_6585_93480)">
                          <g clip-path="url(#clip1_6585_93480)">
                            <path
                              d="M5.24939 13.0677L7.83053 8.61198L8.90223 10.512C9.66287 10.0297 10.2867 9.37531 10.7181 8.60705C11.1495 7.83879 11.375 6.98057 11.3747 6.10888C11.3747 4.63371 10.3541 3.17073 9.33343 2.21148C11.3333 3.00996 13.125 5.02394 13.125 7.22207C13.1249 8.25425 12.8084 9.26385 12.2146 10.1264C11.6207 10.989 10.7755 11.6668 9.783 12.0763L10.7919 13.625L5.24939 13.0677ZM0.875 7.77793C0.875225 6.74578 1.19169 5.73622 1.78542 4.87362C2.37915 4.01102 3.22426 3.33307 4.21656 2.92324L3.20815 1.375L8.74862 1.93135L6.16642 6.38754L5.09733 4.48756C4.33637 4.96966 3.71225 5.62408 3.28066 6.39246C2.84907 7.16083 2.62339 8.01926 2.62383 8.89113C2.62383 10.3663 3.64445 11.8293 4.66508 12.7885C2.66772 11.9915 0.875561 9.97753 0.875561 7.7794L0.875 7.77793Z"
                              fill="currentColor"
                            />
                          </g>
                        </g>
                        <defs>
                          <clipPath id="clip0_6585_93480">
                            <rect
                              width="14"
                              height="14"
                              fill="white"
                              transform="translate(0 0.5)"
                            />
                          </clipPath>
                          <clipPath id="clip1_6585_93480">
                            <rect
                              width="13.363"
                              height="14"
                              fill="white"
                              transform="translate(0.318359 0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 右侧导航 -->
        <div class="qianbao">
          <ul>
            <li @click="$router.push('/withdraw')">
              <a>
                <svg
                  width="31"
                  height="31"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.8639 20.2435H4.13765C3.57777 20.2429 3.04099 20.0202 2.64503 19.6244C2.24906 19.2286 2.02622 18.6918 2.02539 18.132V15.4139C2.71077 15.1483 3.30018 14.6823 3.71669 14.0766C4.1332 13.471 4.35748 12.7539 4.36025 12.0189C4.35738 11.2839 4.13306 10.5668 3.71656 9.96117C3.30006 9.35556 2.71071 8.88953 2.02539 8.62387V5.88757C2.02641 5.32771 2.24936 4.7911 2.64537 4.39535C3.04138 3.99961 3.57814 3.77701 4.13799 3.77637H19.8652C20.4247 3.77739 20.961 4.00018 21.3566 4.39591C21.7521 4.79165 21.9747 5.32805 21.9754 5.88757V8.59237C21.2681 8.84441 20.6559 9.30879 20.2226 9.922C19.7892 10.5352 19.5559 11.2673 19.5544 12.0182C19.5559 12.7693 19.7892 13.5016 20.2225 14.1152C20.6558 14.7287 21.268 15.1935 21.9754 15.4461V18.1323C21.9748 18.6919 21.7523 19.2284 21.3567 19.6242C20.961 20.0199 20.4245 20.2425 19.8649 20.2432L19.8639 20.2435ZM7.32196 9.81597C7.31679 9.81582 7.31164 9.81674 7.30684 9.81866C7.30203 9.82058 7.29766 9.82347 7.29402 9.82714C7.29038 9.83082 7.28752 9.8352 7.28564 9.84002C7.28377 9.84484 7.28289 9.85 7.28308 9.85517V15.5423C7.28349 15.5466 7.28468 15.5507 7.28658 15.5546V15.5588C7.2881 15.5623 7.28938 15.5659 7.29043 15.5696C7.2985 15.5772 7.30915 15.5814 7.32021 15.5815H16.6788C16.6883 15.5801 16.697 15.5754 16.7034 15.5682C16.7098 15.561 16.7135 15.5519 16.7139 15.5423V9.85517C16.7143 9.84535 16.7109 9.83573 16.7044 9.8284C16.6978 9.82106 16.6886 9.8166 16.6788 9.81597H7.32196ZM14.3454 8.99137C14.3681 9.08905 14.4103 9.18117 14.4693 9.26227H16.0443L15.7293 7.89097C15.7283 7.88205 15.7242 7.87374 15.7179 7.86738C15.7115 7.86103 15.7032 7.85701 15.6943 7.85597C15.6911 7.85554 15.688 7.85554 15.6848 7.85597L14.6632 8.08767L13.8582 8.27807L9.59346 9.26017H13.168L14.2229 9.01517L14.3461 8.98822L14.3454 8.99137ZM15.1263 14.7723H8.87803C8.87919 14.7441 8.8772 14.7158 8.8721 14.688C8.86197 14.5922 8.83114 14.4998 8.78178 14.4171C8.78141 14.396 8.77392 14.3756 8.76046 14.3593C8.68321 14.2389 8.57628 14.1403 8.44998 14.073L8.44404 14.0667H8.4381C8.4181 14.0537 8.3953 14.0455 8.37158 14.0429C8.31461 14.0133 8.25167 13.9969 8.18748 13.995C8.15426 13.985 8.11959 13.9807 8.08494 13.9824H8.0825V11.4116C8.22036 11.4108 8.35569 11.3747 8.47557 11.3066C8.59544 11.2385 8.69581 11.1408 8.76708 11.0228C8.84089 10.9002 8.87941 10.7595 8.87838 10.6164H15.1266C15.1249 10.7569 15.1612 10.8952 15.2316 11.0168C15.3001 11.137 15.3992 11.2369 15.5188 11.3063C15.6385 11.3758 15.7744 11.4122 15.9127 11.412V13.9827C15.7038 13.9835 15.5037 14.067 15.3563 14.215C15.2089 14.363 15.1262 14.5634 15.1263 14.7723ZM11.9976 11.496C11.6795 11.4964 11.3747 11.623 11.1498 11.8479C10.925 12.0728 10.7985 12.3777 10.7981 12.6958C10.7981 13.0142 10.9244 13.3196 11.1493 13.545C11.3741 13.7705 11.6792 13.8975 11.9976 13.8984C12.3164 13.898 12.6221 13.7712 12.8475 13.5457C13.073 13.3203 13.1998 13.0146 13.2002 12.6958C13.1997 12.3771 13.0728 12.0716 12.8472 11.8464C12.6217 11.6212 12.3159 11.4948 11.9972 11.4949L11.9976 11.496Z"
                    fill="currentColor"
                  />
                </svg>
                <div>Saque</div>
              </a>
            </li>
            <!-- <li @click="$router.push('/agentData')">
              <a href="#">
                <img src="../../assets/images/person/a081.png" />
                <div>Meus Indicados</div>
              </a>
            </li> -->
            <!-- <div class="line"></div> -->
            <li @click="$parent.isShowRecharge = true">
              <a href="#">
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_6581_48277)">
                    <path
                      d="M4.30117 20.0492C3.74442 20.0486 3.21065 19.8271 2.81696 19.4334C2.42328 19.0397 2.20182 18.506 2.20117 17.9492V6.04922C2.20182 5.49246 2.42328 4.9587 2.81696 4.56501C3.21065 4.17132 3.74442 3.94987 4.30117 3.94922H20.0512C20.6079 3.94987 21.1417 4.17132 21.5354 4.56501C21.9291 4.9587 22.1505 5.49246 22.1512 6.04922V8.05507C21.8603 7.93274 21.5479 7.87002 21.2324 7.87062H12.4719C12.1602 7.87062 11.8515 7.93202 11.5635 8.05132C11.2755 8.17062 11.0138 8.34548 10.7933 8.56591C10.5729 8.78635 10.398 9.04804 10.2787 9.33605C10.1594 9.62406 10.098 9.93275 10.098 10.2445C10.098 10.5562 10.1594 10.8649 10.2787 11.1529C10.398 11.4409 10.5729 11.7026 10.7933 11.9231C11.0138 12.1435 11.2755 12.3184 11.5635 12.4377C11.8515 12.557 12.1602 12.6184 12.4719 12.6184H21.2324C21.5479 12.619 21.8603 12.5564 22.1512 12.4343V17.9492C22.1506 18.506 21.9292 19.0398 21.5355 19.4335C21.1418 19.8272 20.608 20.0487 20.0512 20.0492H4.30117ZM4.07157 16.4393V18.0864C4.07428 18.1673 4.10831 18.2439 4.16646 18.3001C4.22461 18.3564 4.30235 18.3878 4.38325 18.3878C4.46415 18.3878 4.54188 18.3564 4.60003 18.3001C4.65819 18.2439 4.69221 18.1673 4.69492 18.0864V16.4393C4.69632 16.3975 4.6893 16.3558 4.67427 16.3168C4.65923 16.2778 4.6365 16.2422 4.60742 16.2121C4.57834 16.182 4.54351 16.1581 4.505 16.1418C4.46648 16.1254 4.42508 16.117 4.38325 16.117C4.34141 16.117 4.30001 16.1254 4.2615 16.1418C4.22299 16.1581 4.18815 16.182 4.15907 16.2121C4.12999 16.2422 4.10726 16.2778 4.09223 16.3168C4.0772 16.3558 4.07017 16.3975 4.07157 16.4393ZM4.07157 12.9302V14.5773C4.07017 14.6191 4.0772 14.6608 4.09223 14.6998C4.10726 14.7389 4.12999 14.7745 4.15907 14.8046C4.18815 14.8346 4.22299 14.8585 4.2615 14.8749C4.30001 14.8912 4.34141 14.8996 4.38325 14.8996C4.42508 14.8996 4.46648 14.8912 4.505 14.8749C4.54351 14.8585 4.57834 14.8346 4.60742 14.8046C4.6365 14.7745 4.65923 14.7389 4.67427 14.6998C4.6893 14.6608 4.69632 14.6191 4.69492 14.5773V12.9302C4.69221 12.8494 4.65819 12.7727 4.60003 12.7165C4.54188 12.6603 4.46415 12.6288 4.38325 12.6288C4.30235 12.6288 4.22461 12.6603 4.16646 12.7165C4.10831 12.7727 4.07428 12.8494 4.07157 12.9302ZM4.07157 9.42147V11.0665C4.07017 11.1083 4.0772 11.1499 4.09223 11.189C4.10726 11.228 4.12999 11.2636 4.15907 11.2937C4.18815 11.3238 4.22299 11.3477 4.2615 11.364C4.30001 11.3803 4.34141 11.3888 4.38325 11.3888C4.42508 11.3888 4.46648 11.3803 4.505 11.364C4.54351 11.3477 4.57834 11.3238 4.60742 11.2937C4.6365 11.2636 4.65923 11.228 4.67427 11.189C4.6893 11.1499 4.69632 11.1083 4.69492 11.0665V9.42147C4.69632 9.37966 4.6893 9.338 4.67427 9.29896C4.65923 9.25992 4.6365 9.22431 4.60742 9.19424C4.57834 9.16417 4.54351 9.14025 4.505 9.12392C4.46648 9.10759 4.42508 9.09917 4.38325 9.09917C4.34141 9.09917 4.30001 9.10759 4.2615 9.12392C4.22299 9.14025 4.18815 9.16417 4.15907 9.19424C4.12999 9.22431 4.10726 9.25992 4.09223 9.29896C4.0772 9.338 4.07017 9.37966 4.07157 9.42147ZM4.07157 5.91237V7.55947C4.07428 7.64032 4.10831 7.71696 4.16646 7.7732C4.22461 7.82943 4.30235 7.86087 4.38325 7.86087C4.46415 7.86087 4.54188 7.82943 4.60003 7.7732C4.65819 7.71696 4.69221 7.64032 4.69492 7.55947V5.91237C4.69632 5.87056 4.6893 5.8289 4.67427 5.78986C4.65923 5.75082 4.6365 5.71521 4.60742 5.68514C4.57834 5.65507 4.54351 5.63115 4.505 5.61482C4.46648 5.59849 4.42508 5.59007 4.38325 5.59007C4.34141 5.59007 4.30001 5.59849 4.2615 5.61482C4.22299 5.63115 4.18815 5.65507 4.15907 5.68514C4.12999 5.71521 4.10726 5.75082 4.09223 5.78986C4.0772 5.8289 4.07017 5.87056 4.07157 5.91237ZM11.5528 10.2447C11.5513 10.0182 11.617 9.79648 11.7417 9.60748C11.8664 9.41848 12.0444 9.27076 12.2532 9.18307C12.462 9.09538 12.692 9.07167 12.9143 9.11493C13.1366 9.15819 13.341 9.26648 13.5016 9.42607C13.6622 9.58566 13.7718 9.78936 13.8165 10.0113C13.8612 10.2333 13.839 10.4635 13.7526 10.6729C13.6663 10.8822 13.5197 11.0611 13.3315 11.187C13.1433 11.313 12.922 11.3801 12.6956 11.3801C12.3938 11.38 12.1043 11.2606 11.8902 11.0479C11.6761 10.8352 11.5549 10.5464 11.5528 10.2447Z"
                      fill="currentColor"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_6581_48277">
                      <rect
                        width="21"
                        height="21"
                        fill="white"
                        transform="translate(1.5 1.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <div>Depósito</div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="bottom_content">
      <div class="mid_content">
        <div class="vip_content">
          <div class="vip_title">
            <div class="vip_icon">
              VIP{{ vip.vip_info.level }}
            </div>
            <div class="vip_top_content">
              Restantes
              <strong class="vipSpan">VIP{{ vip.vip_info.next_level }}</strong>Valor restante para aposta
              <strong class="vipMoneySpan">{{ vip.vip_info.need_bet }}</strong>
            </div>
            <img
              src="../../assets/images/person/jiantou.png"
              style="width: 0.63158rem; height: 0.63158rem"
              alt=""
              @click="toVip(2)"
            >
          </div>
          <div class="vip_bottom">
            <div class="vip_bottom_img">
              <img
                :src="vip.vip_info.img"
                alt=""
              >
            </div>
            <div class="vip_bottom_text">
              <div class="vip_text">
                <p>Aposta para promoção</p>
                <div class="vip_progress">
                  <div class="vip_progress_line">
                    <div class="vip-progress-outer">
                      <div class="vip-progress-inner">
                        <div
                          class="vip-progress-bg"
                          :style="'width:' + vip.vip_info.next_level_percentage + '%'
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <span class="vip_progress_val">
                  {{ vip.vip_info.total_bet }} / {{ vip.vip_info.next_bet }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="xx_wrap">
      <div class="xinxi" @click="$router.push('vip')">
        <div class="vi_wrap">
          <van-icon name="vip-card-o" class="vip_icon" />
        </div>
        <div class="xinxi_txt">
          <div>
            Para o proximo nivel
            <span>VIP{{ vip.vip_info.next_level || 0 }}</span> Aposta valida
            ainda necessaria
          </div>
          <div class="jine">{{ vip.vip_info.need_bet }}</div>
          <div class="jindu">
            <div>Aposta necessaria</div>
            <div class="myp">
              <Progress
                :percentage="pct"
                :pivot-text="pct + '%'"
                pivot-color="#3bc1e3"
                color="linear-gradient(to right,#3bc1e3, #3bc1e3)"
              />
            </div>
          </div>
        </div>

        <div class="clear"></div>
      </div>
    </div> -->

    <div class="user_uu">
      <!-- <div @click="$router.push('centerWallet')">
        <svg width="25" height="25" fill="currentColor" viewBox="0 0 40 40">
          <rect id="TSGYGNKD-bg" width="40" height="40" opacity="0"></rect>
          <path id="TSGYGNKD-路径_16934" data-name="路径 16934"
            d="M-1186.158,7208.472l-5.187-5.2a16.939,16.939,0,0,1-10.649,3.746A17.007,17.007,0,0,1-1219,7190.007,17.008,17.008,0,0,1-1201.994,7173a17.008,17.008,0,0,1,17.007,17.008,16.937,16.937,0,0,1-3.744,10.646l5.191,5.209a1.849,1.849,0,0,1-.005,2.615,1.841,1.841,0,0,1-1.3.539A1.84,1.84,0,0,1-1186.158,7208.472ZM-1211.4,7180.6a13.222,13.222,0,0,0-3.9,9.412,13.223,13.223,0,0,0,3.9,9.411,13.219,13.219,0,0,0,9.41,3.9,13.224,13.224,0,0,0,9.412-3.9,13.223,13.223,0,0,0,3.9-9.411,13.222,13.222,0,0,0-3.9-9.412,13.222,13.222,0,0,0-9.412-3.9A13.217,13.217,0,0,0-1211.4,7180.6Zm4.243,15.323c-1.387-.555-2.176-1.294-2.222-2.086h0v-1.6a6.509,6.509,0,0,0,1.725,1,15.451,15.451,0,0,0,5.67.972,15.453,15.453,0,0,0,5.669-.972,6.525,6.525,0,0,0,1.723-1v1.464c0,.02,0,.042,0,.061s0,.042,0,.062v.014c-.048.792-.839,1.533-2.226,2.086a14.4,14.4,0,0,1-5.166.86A14.406,14.406,0,0,1-1207.161,7195.918Zm0-3.748c-1.387-.555-2.176-1.294-2.222-2.085h0v-1.6a6.5,6.5,0,0,0,1.725,1,15.462,15.462,0,0,0,5.67.972,15.463,15.463,0,0,0,5.669-.972,6.512,6.512,0,0,0,1.723-1v1.466c0,.02,0,.042,0,.062s0,.041,0,.061v.015c-.048.791-.839,1.532-2.226,2.085a14.4,14.4,0,0,1-5.166.86A14.406,14.406,0,0,1-1207.161,7192.17Zm-2.226-5.915c0-1.669,3.312-3.021,7.395-3.021s7.392,1.352,7.392,3.021-3.31,3.022-7.392,3.022S-1209.387,7187.925-1209.387,7186.255Z"
            transform="translate(1220 -7171.008)"></path>
        </svg>
        <p>Recuperar o Saldo</p>
        <img src="../../assets/images/person/jiantou.png" alt="" class="jiantou" />
      </div> -->
      <div @click="toRecord(0)">
        <svg
          width="25"
          height="25"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.8074 44.6718C27.194 43.5968 25.0343 41.6488 23.6963 39.1597C22.3583 36.6706 21.925 33.7946 22.4701 31.0218C23.0153 28.2489 24.5052 25.7508 26.6858 23.9534C28.8664 22.1559 31.6027 21.1702 34.4287 21.1643C37.6651 21.1572 40.7718 22.4354 43.0661 24.718C45.0699 26.7107 46.3208 29.3366 46.6052 32.1482C46.8897 34.9599 46.1902 37.7831 44.6262 40.1368C43.5115 41.8149 41.9992 43.1912 40.2237 44.143C38.4481 45.0948 36.4646 45.5925 34.4501 45.5918C32.8573 45.5914 31.28 45.2788 29.8074 44.6718ZM28.2526 27.1555C26.8144 28.5746 25.9128 30.4486 25.7019 32.458C25.4911 34.4673 25.9837 36.4876 27.0959 38.1743C28.2077 39.861 29.8704 41.1098 31.7999 41.708C33.7295 42.3061 35.8068 42.2164 37.6776 41.4543C39.5486 40.692 41.0973 39.3044 42.0596 37.5281C43.022 35.7517 43.3384 33.6966 42.955 31.713C42.5715 29.7295 41.512 27.9405 39.957 26.6508C38.402 25.3611 36.4477 24.6507 34.4275 24.6405H34.3851C32.0901 24.641 29.8875 25.5449 28.2538 27.1568L28.2526 27.1555ZM8.80493 44.8705C7.35648 44.8617 5.97002 44.2824 4.94568 43.2583C3.92133 42.2342 3.3417 40.8477 3.33252 39.3993V9.87553C3.34008 8.42657 3.91915 7.03913 4.94385 6.01467C5.96854 4.99021 7.35598 4.41152 8.80493 4.4043H33.2098C34.6586 4.41185 36.0459 4.9907 37.0703 6.01513C38.0947 7.03955 38.6738 8.42679 38.6813 9.87553V18.6468C37.4133 18.2624 36.0973 18.0579 34.7723 18.0393V9.78928C34.7732 9.58388 34.7335 9.38037 34.6552 9.19048C34.5768 9.0006 34.4615 8.8281 34.3161 8.68301C34.1712 8.53739 33.9989 8.42217 33.8089 8.34404C33.6189 8.26591 33.4152 8.22647 33.2098 8.22803H8.80493C8.59937 8.22658 8.39571 8.26607 8.20557 8.34419C8.01542 8.42231 7.84292 8.53747 7.69775 8.68301C7.5527 8.82828 7.43771 9.00085 7.35962 9.19071C7.28153 9.38057 7.24156 9.58399 7.24243 9.78928V39.3193C7.2417 39.5245 7.28154 39.728 7.35962 39.9178C7.4377 40.1076 7.55281 40.2802 7.69775 40.4255C7.8433 40.5706 8.01551 40.6854 8.20557 40.7635C8.39562 40.8416 8.59946 40.8814 8.80493 40.8805H21.0547C21.9251 42.3609 23.0082 43.7056 24.2688 44.8718L8.80493 44.8705ZM34.4037 39.2393C34.4037 39.2393 34.4038 39.2393 32.6163 39.223C33.4091 38.3913 33.9948 37.3846 34.3262 36.2843C33.7523 36.7466 33.1009 37.1034 32.4023 37.338C31.9622 37.4229 31.5083 37.4018 31.0779 37.2763C30.6475 37.1509 30.253 36.9248 29.9274 36.6168C29.6013 36.3089 29.3534 35.9278 29.2041 35.505C29.0548 35.0822 29.0082 34.6299 29.0686 34.1855C29.1449 31.7368 31.8849 30.6855 34.4174 27.5605C36.9099 30.7218 39.6987 31.8105 39.7424 34.248C39.7955 34.6925 39.742 35.1431 39.5862 35.5626C39.4303 35.9822 39.1765 36.3586 38.8461 36.6605C38.5162 36.9627 38.1192 37.1819 37.6877 37.2999C37.2562 37.418 36.8028 37.4314 36.3651 37.3393C35.6886 37.1028 35.0626 36.7411 34.52 36.273C34.8369 37.3828 35.4092 38.4029 36.1911 39.2518L34.4037 39.2393ZM20.4437 24.718H12.8186C12.2898 24.7128 11.7845 24.5004 11.4105 24.1265C11.0366 23.7525 10.8237 23.2469 10.8185 22.718C10.815 22.4552 10.8644 22.1943 10.9631 21.9506C11.0619 21.707 11.2085 21.4856 11.394 21.2993C11.5805 21.1134 11.8018 20.9667 12.0459 20.868C12.29 20.7692 12.5516 20.7204 12.8149 20.7243H20.4401C20.7027 20.7243 20.9628 20.776 21.2054 20.8765C21.4481 20.977 21.6685 21.1244 21.8542 21.3101C22.04 21.4958 22.1871 21.7163 22.2876 21.9589C22.3881 22.2016 22.4402 22.4616 22.4402 22.7243C22.4402 23.2547 22.2293 23.7634 21.8542 24.1385C21.4792 24.5136 20.9705 24.7243 20.4401 24.7243L20.4437 24.718ZM26.9501 18.1255H12.7002C12.1715 18.12 11.666 17.9075 11.2921 17.5336C10.9182 17.1598 10.7056 16.6542 10.7001 16.1255C10.6962 15.8621 10.7451 15.6006 10.8441 15.3565C10.9431 15.1124 11.0901 14.8906 11.2762 14.7043C11.4622 14.5181 11.6835 14.3712 11.9275 14.2724C12.1714 14.1736 12.4334 14.125 12.6965 14.1293H26.9464C27.4751 14.1348 27.9806 14.3473 28.3545 14.7212C28.7284 15.0951 28.9407 15.6005 28.9462 16.1293C28.9499 16.3924 28.9009 16.6537 28.8019 16.8976C28.7029 17.1415 28.5561 17.3631 28.3701 17.5493C28.1873 17.7319 27.97 17.8766 27.7313 17.9753C27.4926 18.074 27.2371 18.1246 26.9788 18.1243L26.9501 18.1255Z"
            fill=""
            class="firstPath"
          />
        </svg>
        <p>Lista De Retirada</p>
        <img
          src="../../assets/images/person/jiantou.png"
          alt=""
          class="jiantou"
        >
      </div>
      <div @click="toRecord(1)">
        <svg
          width="25"
          height="25"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.7825 44.5269C27.1693 43.4517 25.0098 41.5036 23.672 39.0145C22.3343 36.5255 21.9011 33.6495 22.4462 30.8768C22.9912 28.1038 24.481 25.6057 26.6617 23.8081C28.8424 22.0106 31.579 21.025 34.405 21.0194C37.6412 21.0132 40.7477 22.2913 43.0425 24.5731C45.0461 26.5659 46.2967 29.1917 46.5814 32.0032C46.8661 34.8147 46.1672 37.6379 44.6037 39.9918C43.4889 41.6698 41.9764 43.046 40.2009 43.9978C38.4254 44.9496 36.442 45.4473 34.4275 45.4469C32.8339 45.4465 31.2559 45.134 29.7825 44.5269ZM28.2288 27.0107C26.7905 28.4294 25.889 30.3032 25.6781 32.3124C25.4672 34.3216 25.9601 36.3417 27.0725 38.0281C28.1845 39.7149 29.847 40.9638 31.7767 41.562C33.7065 42.1601 35.7839 42.0704 37.655 41.3081C39.5258 40.5457 41.0743 39.158 42.0367 37.3817C42.999 35.6055 43.3156 33.5504 42.9325 31.5668C42.5487 29.5835 41.4891 27.7945 39.9342 26.5049C38.3792 25.2153 36.4251 24.5048 34.405 24.4944H34.3613C32.0658 24.4942 29.8625 25.3982 28.2288 27.0107ZM24.6387 44.6981H5.60249C5.00132 44.6978 4.42481 44.459 3.99948 44.0341C3.57415 43.6093 3.33473 43.033 3.33374 42.4319C3.3344 41.8305 3.57366 41.2539 3.99902 40.8288C4.42439 40.4036 5.0011 40.1647 5.60249 40.1643H20.9775C21.8994 41.8948 23.1433 43.4332 24.6425 44.6969L24.6387 44.6981ZM34.405 39.2393C34.405 39.2393 34.405 39.2456 32.6163 39.2231C33.4093 38.3915 33.9951 37.3847 34.3262 36.2843C33.7525 36.747 33.1011 37.1043 32.4025 37.3394C31.962 37.4243 31.5077 37.403 31.077 37.2774C30.6464 37.1517 30.2519 36.9254 29.9262 36.6169C29.6005 36.3091 29.3528 35.9281 29.2037 35.5055C29.0546 35.0829 29.0083 34.6309 29.0688 34.1869C29.145 31.7369 31.885 30.6869 34.4175 27.5619C36.91 30.7219 39.6988 31.8119 39.7425 34.2506C39.7955 34.6949 39.742 35.1454 39.5863 35.565C39.4307 35.9845 39.1775 36.3609 38.8475 36.6631C38.5173 36.9647 38.12 37.1835 37.6886 37.3013C37.2572 37.4191 36.8039 37.4325 36.3663 37.3406C35.6892 37.104 35.0628 36.7418 34.52 36.2731C34.8368 37.3833 35.4092 38.4038 36.1913 39.2531L34.405 39.2393ZM19.5175 36.2019H5.60249C5.00132 36.2015 4.42481 35.9627 3.99948 35.5379C3.57415 35.113 3.33473 34.5368 3.33374 33.9356C3.33473 33.3343 3.57411 32.758 3.9994 32.3329C4.4247 31.9079 5.0012 31.6688 5.60249 31.6681H19.2175C19.185 32.0781 19.1675 32.4981 19.1675 32.9181C19.167 34.0229 19.2848 35.1246 19.5187 36.2044L19.5175 36.2019ZM20.0175 27.8681H5.60249C5.00132 27.8678 4.42481 27.629 3.99948 27.2041C3.57415 26.7793 3.33473 26.2031 3.33374 25.6019C3.3344 25.0004 3.57362 24.4237 3.99895 23.9983C4.42428 23.573 5.00099 23.3338 5.60249 23.3331H22.5063C21.4245 24.6929 20.5813 26.2263 20.0125 27.8681H20.0175ZM26.925 19.5344H5.60249C5.00153 19.534 4.42523 19.2954 3.99994 18.8708C3.57464 18.4463 3.33506 17.8703 3.33374 17.2694C3.3344 16.6679 3.57362 16.0911 3.99895 15.6658C4.42428 15.2405 5.00099 15.0013 5.60249 15.0006H35.7275C36.3146 15.0022 36.8775 15.2353 37.2938 15.6493C37.5058 15.8625 37.6724 16.1164 37.7837 16.3956C37.8949 16.6749 37.9485 16.9739 37.9412 17.2744C37.941 17.4705 37.9158 17.6658 37.8662 17.8556C36.7864 17.6219 35.6848 17.5042 34.58 17.5043C31.8931 17.5025 29.2525 18.2032 26.92 19.5369L26.925 19.5344ZM5.60745 10.8619C5.00551 10.8626 4.42796 10.6242 4.00162 10.1993C3.57528 9.77435 3.33506 9.19752 3.33374 8.59558C3.3344 7.99419 3.57366 7.4177 3.99902 6.99257C4.42439 6.56744 5.0011 6.32846 5.60249 6.32812H35.7275C36.3135 6.32966 36.8752 6.56284 37.29 6.97685C37.502 7.19 37.6686 7.44389 37.7799 7.72316C37.8912 8.00243 37.9448 8.3013 37.9375 8.60184C37.9368 9.20301 37.6977 9.77937 37.2726 10.2045C36.8475 10.6296 36.2712 10.8687 35.67 10.8694L5.60745 10.8619Z"
            fill=""
            class="twoPath"
          />
        </svg>
        <p>Lista De Depósito</p>
        <img
          src="../../assets/images/person/jiantou.png"
          alt=""
          class="jiantou"
        >
      </div>
      <div @click="toRecord(2)">
        <svg
          width="25"
          height="25"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_11_484)">
            <path
              d="M43.5912 45.2413L40.8325 42.4825C38.8306 43.962 36.4054 44.7571 33.9162 44.75C32.3834 44.7542 30.865 44.4543 29.4489 43.8677C28.0327 43.2811 26.747 42.4194 25.6662 41.3325C24.5793 40.2517 23.7176 38.966 23.131 37.5499C22.5444 36.1337 22.2445 34.6153 22.2487 33.0825C22.2446 31.5497 22.5445 30.0313 23.1311 28.6152C23.7177 27.199 24.5794 25.9134 25.6662 24.8325C26.747 23.7456 28.0327 22.884 29.4489 22.2973C30.865 21.7107 32.3834 21.4108 33.9162 21.415C35.449 21.4109 36.9674 21.7109 38.3835 22.2975C39.7996 22.8841 41.0853 23.7457 42.1662 24.8325C43.253 25.9134 44.1147 27.199 44.7013 28.6152C45.2879 30.0313 45.5878 31.5497 45.5837 33.0825C45.589 35.5586 44.8005 37.9713 43.3337 39.9662L46.0962 42.7288C46.3291 42.9464 46.4992 43.2225 46.5887 43.5284C46.6782 43.8343 46.6838 44.1587 46.605 44.4675C46.5262 44.7765 46.3656 45.0585 46.1401 45.2839C45.9147 45.5094 45.6327 45.6699 45.3237 45.7487C45.1796 45.7859 45.0313 45.8049 44.8825 45.805C44.6401 45.8042 44.4005 45.7538 44.1785 45.6569C43.9564 45.5599 43.7565 45.4185 43.5912 45.2413ZM26.0025 33.0838C26.0048 35.1819 26.8393 37.1934 28.3229 38.677C29.8065 40.1606 31.8181 40.9952 33.9162 40.9975C36.0143 40.9952 38.0259 40.1606 39.5095 38.677C40.9931 37.1934 41.8276 35.1819 41.83 33.0838C41.8276 30.9856 40.9931 28.974 39.5095 27.4904C38.0259 26.0068 36.0143 25.1723 33.9162 25.17C31.8181 25.1723 29.8065 26.0068 28.3229 27.4904C26.8393 28.974 26.0048 30.9856 26.0025 33.0838ZM8.80371 44.8725C7.35583 44.8649 5.96933 44.2868 4.94505 43.2634C3.92076 42.2401 3.34132 40.8541 3.33246 39.4062V9.88248C3.3387 8.43287 3.91697 7.04438 4.94154 6.01888C5.9661 4.99337 7.35411 4.41381 8.80371 4.40625H33.2075C34.6562 4.4138 36.0434 4.99269 37.0679 6.01712C38.0923 7.04155 38.6711 8.42878 38.6787 9.87752V18.6475C37.4106 18.2634 36.0948 18.0593 34.77 18.0413V9.79123C34.7707 9.58585 34.7307 9.38242 34.6524 9.19255C34.5741 9.00269 34.459 8.83013 34.3137 8.68497C34.1685 8.53948 33.9958 8.42434 33.8057 8.34622C33.6155 8.26811 33.4118 8.22864 33.2062 8.23003H8.80121C8.59588 8.22888 8.39237 8.2685 8.20247 8.3466C8.01257 8.42471 7.84007 8.53969 7.69497 8.68497C7.54957 8.83005 7.43438 9.00259 7.35607 9.19247C7.27775 9.38236 7.23786 9.58583 7.23871 9.79123V39.3213C7.238 39.5266 7.27795 39.7301 7.35626 39.92C7.43456 40.1099 7.54968 40.2824 7.69497 40.4275C7.8404 40.5724 8.01296 40.687 8.20278 40.7651C8.3926 40.8432 8.59596 40.8831 8.80121 40.8825H21.0512C21.9216 42.3629 23.0043 43.7076 24.265 44.8738L8.80371 44.8725ZM20.4425 24.72H12.8175C12.2886 24.7148 11.783 24.5024 11.409 24.1285C11.0351 23.7545 10.8227 23.2488 10.8175 22.72C10.8142 22.4571 10.8634 22.1961 10.9624 21.9525C11.0613 21.7088 11.208 21.4874 11.3937 21.3012C11.5799 21.1152 11.8015 20.9686 12.0454 20.8698C12.2893 20.771 12.5506 20.7222 12.8137 20.7263H20.4387C20.9691 20.7263 21.4779 20.937 21.8529 21.3121C22.228 21.6871 22.4387 22.1958 22.4387 22.7263C22.4387 23.2567 22.228 23.7654 21.8529 24.1404C21.4779 24.5155 20.9691 24.7262 20.4387 24.7262L20.4425 24.72ZM26.9425 18.1263H12.6925C12.1636 18.1211 11.658 17.9086 11.284 17.5347C10.9101 17.1607 10.6977 16.655 10.6925 16.1262C10.6884 15.8628 10.7373 15.6013 10.8363 15.3571C10.9353 15.113 11.0823 14.8912 11.2687 14.705C11.4547 14.5189 11.6763 14.372 11.9203 14.2732C12.1642 14.1744 12.4256 14.1257 12.6887 14.13H26.9387C27.4674 14.1355 27.9729 14.348 28.3468 14.7219C28.7207 15.0958 28.9332 15.6013 28.9387 16.13C28.9427 16.3933 28.8937 16.6545 28.7947 16.8985C28.6957 17.1424 28.5487 17.364 28.3625 17.55C28.18 17.7326 27.9633 17.8774 27.7248 17.976C27.4862 18.0747 27.2306 18.1253 26.9725 18.125L26.9425 18.1263Z"
              fill="#EBC96F"
            />
          </g>
          <defs>
            <clipPath id="clip0_11_484">
              <rect
                width="50"
                height="50"
                fill="white"
              />
            </clipPath>
          </defs>
        </svg>
        <p>Ordem</p>
        <img
          src="../../assets/images/person/jiantou.png"
          alt=""
          class="jiantou"
        >
      </div>
      <div @click="$router.push('/agent')">
        <svg
          width="25"
          height="25"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_11_483)">
            <path
              d="M30.5838 43.28L30.3337 41.7062L30.2513 41.6238L28.76 42.2038C28.2056 42.4268 27.5891 42.4413 27.0249 42.2446C26.4606 42.0478 25.9868 41.6531 25.6913 41.1337L23.7001 37.7338C23.4172 37.2225 23.3204 36.6289 23.4262 36.0543C23.5319 35.4797 23.8337 34.9596 24.28 34.5825L25.6163 33.5825V33.4062L24.3737 32.4062C23.8973 32.0511 23.5728 31.5289 23.4652 30.9445C23.3577 30.36 23.475 29.7565 23.7937 29.255L25.785 25.855C26.0721 25.3485 26.5314 24.9619 27.0795 24.7656C27.6276 24.5692 28.2279 24.5761 28.7712 24.785L30.345 25.365L30.4288 25.2812L30.6787 23.6212C30.7598 23.0426 31.0488 22.5133 31.4916 22.1321C31.9344 21.751 32.5008 21.544 33.0851 21.55H37.065C37.6645 21.5363 38.2467 21.7513 38.6934 22.1513C39.1401 22.5514 39.4178 23.1064 39.47 23.7038L39.72 25.2812L39.8025 25.365L41.2937 24.785C41.8482 24.562 42.4646 24.5475 43.0289 24.7442C43.5932 24.9409 44.067 25.3356 44.3625 25.855L46.3538 29.255C46.6364 29.7663 46.7331 30.3598 46.6273 30.9344C46.5216 31.509 46.22 32.0291 45.7738 32.4062L44.4375 33.4062V33.5726L45.7738 34.5725C46.2302 34.9412 46.5454 35.4561 46.6661 36.0302C46.7868 36.6044 46.7056 37.2026 46.4363 37.7238L44.445 41.1987C44.1308 41.6988 43.6558 42.077 43.0981 42.2713C42.5404 42.4655 41.9332 42.4642 41.3763 42.2675L39.8025 41.6875L39.72 41.7713L39.47 43.4275C39.3376 43.9899 39.0204 44.4917 38.5693 44.8526C38.1181 45.2136 37.5591 45.4129 36.9813 45.4188L36.9712 45.4375H32.94C32.3486 45.4376 31.7787 45.2161 31.3425 44.8168C30.9063 44.4174 30.6356 43.8691 30.5838 43.28ZM31.2538 38.7288C31.5912 38.9793 31.9492 39.2009 32.3238 39.3913L33.0738 39.7225L33.4988 42.3688H36.4012L36.8163 39.6325L37.5663 39.3012C37.9405 39.1108 38.298 38.8892 38.6351 38.6388L39.2975 38.1387L41.8688 39.1387L43.3688 36.5675L41.2113 34.9113L41.2937 34.0825V32.8325L41.2113 32.0038L43.3688 30.3438L41.8688 27.7751L39.2975 28.775L38.6351 28.275C38.298 28.0245 37.9405 27.803 37.5663 27.6125L36.8163 27.2775L36.4012 24.5438H33.4838L33.07 27.2775L32.3201 27.6125C31.9285 27.7714 31.5667 27.9953 31.25 28.275L30.5875 28.775L28.0162 27.7751L26.525 30.3438L28.6825 32.0038L28.6 32.8325V34.1688L28.6825 34.9975L26.525 36.6538L28.0162 39.225L30.5875 38.225L31.2538 38.7288ZM41.6288 27.275C41.62 27.3575 41.7088 27.3576 41.6201 27.2738L41.6288 27.275ZM20.7238 37.9388H8.17127C7.5356 37.9405 6.90588 37.816 6.31862 37.5727C5.73136 37.3294 5.19821 36.972 4.75002 36.5212C3.84331 35.6084 3.33424 34.3742 3.33377 33.0876V11.5163C3.33143 10.8787 3.45561 10.247 3.69914 9.65783C3.94268 9.06863 4.30074 8.53358 4.75254 8.08374C5.20172 7.6328 5.73575 7.2753 6.32381 7.0318C6.91187 6.78829 7.54227 6.66367 8.17874 6.66505H40.1563C40.7926 6.66363 41.4228 6.78821 42.0107 7.03172C42.5985 7.27523 43.1324 7.63278 43.5813 8.08374C44.0331 8.53353 44.3912 9.06854 44.6347 9.65776C44.8783 10.247 45.0024 10.8787 45 11.5163V22.2738C43.838 21.2433 42.5226 20.3999 41.1013 19.7738V19.1488H39.405C37.992 18.7217 36.5237 18.5052 35.0475 18.5063C33.5713 18.5053 32.1031 18.7218 30.69 19.1488H7.23255V33.2738C7.23641 33.5249 7.33788 33.7646 7.51544 33.9421C7.69301 34.1197 7.9327 34.2211 8.18378 34.225L20.0588 34.1087C20.109 35.4122 20.3292 36.7035 20.7138 37.95L20.7238 37.9388ZM8.20377 10.6525C7.95177 10.6538 7.71046 10.7544 7.53215 10.9325C7.35384 11.1106 7.25288 11.3518 7.25124 11.6038V15.2287H41.1V11.6038C41.0955 11.3527 40.9937 11.1131 40.816 10.9357C40.6383 10.7582 40.3986 10.6567 40.1475 10.6525H8.19499H8.20377ZM32.175 33.4125C32.175 32.6646 32.4721 31.9473 33.001 31.4185C33.5298 30.8896 34.2471 30.5925 34.995 30.5925C35.7429 30.5925 36.4602 30.8896 36.9891 31.4185C37.5179 31.9473 37.8151 32.6646 37.8151 33.4125C37.8076 34.1581 37.508 34.871 36.9808 35.3983C36.4535 35.9255 35.7406 36.2251 34.995 36.2325C34.6238 36.2337 34.2561 36.1616 33.9128 36.0203C33.5696 35.879 33.2577 35.6714 32.9949 35.4093C32.7321 35.1471 32.5236 34.8357 32.3814 34.4928C32.2392 34.15 32.1661 33.7824 32.1662 33.4113L32.175 33.4125ZM11.8938 26.4362C11.657 26.4341 11.4231 26.3839 11.2062 26.2888C10.9892 26.1933 10.7933 26.0558 10.6298 25.8842C10.4663 25.7125 10.3385 25.5102 10.2538 25.2888C10.1685 25.069 10.1281 24.8344 10.135 24.5988C10.1421 24.1133 10.3381 23.6497 10.6814 23.3064C11.0247 22.9631 11.4883 22.7671 11.9738 22.76H17.755C17.9897 22.7602 18.2222 22.8052 18.44 22.8925C18.6641 22.9845 18.8676 23.12 19.0388 23.2913C19.2107 23.4619 19.3455 23.6661 19.435 23.8912C19.5264 24.1162 19.5714 24.3572 19.5675 24.6C19.5591 25.0854 19.3618 25.5485 19.0176 25.8909C18.6734 26.2333 18.2093 26.4279 17.7238 26.4337L11.8938 26.4362Z"
              fill=""
              class="threePath"
            />
          </g>
          <defs>
            <clipPath id="clip0_11_483">
              <rect
                width="50"
                height="50"
                fill="white"
              />
            </clipPath>
          </defs>
        </svg>
        <p>{{ $t("我的团队") }}</p>
        <img
          src="../../assets/images/person/jiantou.png"
          alt=""
          class="jiantou"
        >
      </div>
    </div>
    <div class="marginDiv" />
    <div class="user_bottom">
      <div @click="$router.push('/agent')">
        <svg
          width="20"
          height="20"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_6581_88290)">
            <path
              d="M7.33301 38.0002C5.93267 38.0119 4.58482 37.4679 3.58508 36.4872C2.58534 35.5066 2.01531 34.1695 2 32.7692V9.23114C2.01531 7.83084 2.58534 6.49374 3.58508 5.51313C4.58482 4.53251 5.93267 3.98845 7.33301 4.00019H20.667C21.109 4.00045 21.5329 4.17615 21.8455 4.48871C22.158 4.80128 22.3337 5.22514 22.334 5.66718C22.3337 6.10921 22.158 6.53308 21.8455 6.84564C21.5329 7.15821 21.109 7.33391 20.667 7.33417V7.34918H7.33301C6.80794 7.34465 6.30248 7.54858 5.92755 7.9162C5.55262 8.28382 5.33881 8.78518 5.33301 9.31024V32.7681C5.33881 33.2933 5.55259 33.7948 5.92749 34.1625C6.30239 34.5303 6.80784 34.7344 7.33301 34.7302H31.333C31.8583 34.7347 32.3638 34.5306 32.7388 34.1628C33.1138 33.7949 33.3275 33.2934 33.333 32.7681V22.6682C33.3329 22.4492 33.3759 22.2323 33.4596 22.03C33.5433 21.8276 33.6661 21.6437 33.8209 21.4888C33.9757 21.3339 34.1595 21.211 34.3618 21.1271C34.5642 21.0433 34.781 21.0002 35 21.0002C35.4419 21.0002 35.8656 21.1757 36.178 21.4881C36.4905 21.8005 36.666 22.2243 36.666 22.6662V32.7662C36.6509 34.1667 36.0809 35.5041 35.0808 36.4848C34.0808 37.4655 32.7326 38.0094 31.332 37.9971L7.33301 38.0002ZM16.403 26.3002C16.1842 26.295 15.9685 26.2467 15.7684 26.1581C15.5683 26.0696 15.3875 25.9426 15.2365 25.7841C15.0855 25.6257 14.9672 25.439 14.8884 25.2348C14.8095 25.0306 14.7717 24.813 14.777 24.5942C14.8834 22.9591 15.2368 21.3495 15.825 19.8201C16.7524 17.1363 18.4847 14.8037 20.786 13.1402C23.5657 11.2278 26.8367 10.1553 30.209 10.0502L28.154 7.99518C27.8418 7.68245 27.6664 7.25863 27.6664 6.81671C27.6664 6.3748 27.8418 5.95086 28.154 5.63813C28.4666 5.32565 28.8905 5.15021 29.3325 5.15021C29.7745 5.15021 30.1984 5.32565 30.511 5.63813L35.696 10.8232C36.0085 11.1358 36.184 11.5597 36.184 12.0017C36.184 12.4436 36.0085 12.8676 35.696 13.1802L30.511 18.3652C30.1984 18.6776 29.7745 18.8532 29.3325 18.8532C28.8905 18.8532 28.4666 18.6776 28.154 18.3652C27.8415 18.0526 27.666 17.6287 27.666 17.1867C27.666 16.7447 27.8415 16.3208 28.154 16.0082L30.806 13.3561C22.717 13.7011 19.924 18.1632 18.968 20.9272L18.956 20.9601C18.4943 22.1507 18.2087 23.4023 18.108 24.6752C18.0973 25.1101 17.9171 25.5236 17.6059 25.8276C17.2947 26.1315 16.877 26.3018 16.442 26.3022L16.403 26.3002Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_6581_88290">
              <rect
                width="40"
                height="40"
                fill="white"
              />
            </clipPath>
          </defs>
        </svg>
        <p>Agente</p>
        <img
          src="../../assets/images/person/jiantou.png"
          alt=""
          class="jiantou"
        >
      </div>
      <div @click="$router.push('/setting')">
        <svg
          width="20"
          height="20"
          fill="currentColor"
          viewBox="0 0 40 40"
        >
          <rect
            id="etHw9uDt-bg"
            width="40"
            height="40"
            opacity="0"
          />
          <g
            id="etHw9uDt-icon_personal_info"
            data-name="icon_personal info"
            transform="translate(1.169 1.32)"
          >
            <path
              id="etHw9uDt-路径_16893"
              data-name="路径 16893"
              d="M-236.922-967.117h-17.693a1.646,1.646,0,0,1-1.644-1.644v-2.621a12.083,12.083,0,0,1,.953-4.721,12.131,12.131,0,0,1,2.6-3.854,12.115,12.115,0,0,1,3.855-2.6,12.728,12.728,0,0,1,4.722-.953h7.208a1.646,1.646,0,0,1,1.643,1.645,1.645,1.645,0,0,1-1.643,1.644h-7.208a8.85,8.85,0,0,0-8.84,8.84v.977h16.048a1.645,1.645,0,0,1,1.643,1.644A1.645,1.645,0,0,1-236.922-967.117Zm3.964-.263a1.5,1.5,0,0,1-1.066-.443,1.514,1.514,0,0,1-.442-1.136l.173-3.956a1.511,1.511,0,0,1,.442-1.006l8.884-8.885a1.508,1.508,0,0,1,1.072-.443,1.505,1.505,0,0,1,1.071.443l3.785,3.785a1.519,1.519,0,0,1,0,2.143l-8.885,8.883a1.521,1.521,0,0,1-1.006.442l-3.956.172Zm9.062-12.211h0l-7.4,7.4-.073,1.718,1.718-.076,7.394-7.394-1.642-1.643Zm-13.677-5.873a9.518,9.518,0,0,1-9.508-9.506,9.518,9.518,0,0,1,9.508-9.508,9.518,9.518,0,0,1,9.507,9.508A9.517,9.517,0,0,1-237.574-985.464Zm0-15.726a6.227,6.227,0,0,0-6.22,6.22,6.226,6.226,0,0,0,6.22,6.218,6.225,6.225,0,0,0,6.218-6.218A6.226,6.226,0,0,0-237.574-1001.19Z"
              transform="translate(256.259 1004.478)"
            />
          </g>
        </svg>
        <p>Dados</p>
        <img
          src="../../assets/images/person/jiantou.png"
          alt=""
          class="jiantou"
        >
      </div>
      <div @click="$router.push('/setting')">
        <svg
          width="20"
          height="20"
          fill="currentColor"
          viewBox="0 0 40 40"
        >
          <rect
            id="OSIduI9Q-bg"
            width="40"
            height="40"
            opacity="0"
          />
          <path
            id="OSIduI9Q-icon_wd_sec"
            d="M14.135,37.067c-15.395-5.378-17-17.957-16.822-27.23.017-.835.038-1.874.038-2.813A1.587,1.587,0,0,1-1.07,5.431c5.337,0,11.24-1.663,14.621-4.977a1.564,1.564,0,0,1,2.206,0c3.379,3.311,9.233,4.915,14.572,4.915a1.588,1.588,0,0,1,1.58,1.594c0,.862.017,1.753.037,2.812h0c.175,9.273-1.378,21.911-16.775,27.29a1.556,1.556,0,0,1-1.036,0ZM.5,8.576C.5,8.857.485,9.335.474,9.9c.152,9.387,1.475,19.263,14.18,23.972,12.7-4.709,13.923-14.224,14.131-24.034-.01-.545-.017-.937-.023-1.321-4.954-.261-10.667-1.455-14.108-4.4C11.211,7.061,5.449,8.316.5,8.576Zm11.96,14.666L8.949,19.7a1.6,1.6,0,0,1,0-2.252,1.572,1.572,0,0,1,2.234,0l2.394,2.411,5.9-5.948a1.563,1.563,0,0,1,1.117-.466h0a1.559,1.559,0,0,1,1.117.467,1.6,1.6,0,0,1,0,2.252l-7.017,7.074a1.575,1.575,0,0,1-2.237,0Z"
            transform="translate(5.37 1.422)"
          />

        </svg>
        <p>Segurança</p>
        <img
          src="../../assets/images/person/jiantou.png"
          alt=""
          class="jiantou"
        >
      </div>
      <div @click="toVip(1)">
        <svg
          width="20"
          height="20"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M40 23.75C40 32.7246 32.7246 40 23.75 40C14.7754 40 7.5 32.7246 7.5 23.75C7.5 14.7754 14.7754 7.5 23.75 7.5C32.7246 7.5 40 14.7754 40 23.75ZM36.9045 40.4401C33.2863 43.2957 28.7172 45 23.75 45C12.0139 45 2.5 35.486 2.5 23.75C2.5 12.0139 12.0139 2.5 23.75 2.5C35.486 2.5 45 12.0139 45 23.75C45 28.7172 43.2957 33.2863 40.4401 36.9045L46.7678 43.2322C47.7441 44.2085 47.7441 45.7915 46.7678 46.7678C45.7915 47.7441 44.2085 47.7441 43.2322 46.7678L36.9045 40.4401Z"
            fill="var(--cms-primary-color)"
          />
          <path
            d="M24.375 22.5C29.5527 22.5 33.75 20.8211 33.75 18.75C33.75 16.6789 29.5527 15 24.375 15C19.1973 15 15 16.6789 15 18.75C15 20.8211 19.1973 22.5 24.375 22.5Z"
            fill="var(--cms-primary-color)"
          />
          <path
            d="M31.597 23.6218C29.6402 24.3552 27.0754 24.7592 24.375 24.7592C21.6746 24.7592 19.1098 24.3552 17.153 23.6218C16.2574 23.2861 15.5525 22.9047 15 22.5V23.9861C15 24.9247 15.9751 25.8071 17.7459 26.4707C19.5166 27.1345 21.8708 27.5 24.375 27.5C26.8792 27.5 29.2334 27.1345 31.0041 26.4708C32.7748 25.8071 33.75 24.9247 33.75 23.9861V22.5C33.1975 22.9047 32.4926 23.2861 31.597 23.6218Z"
            fill="var(--cms-primary-color)"
          />
          <path
            d="M31.597 28.5911C29.6402 29.3045 27.0754 29.6974 24.375 29.6974C21.6746 29.6974 19.1098 29.3045 17.153 28.591C16.2574 28.2645 15.5525 27.8936 15 27.4999V29.0822C15 30.9699 19.1973 32.5002 24.375 32.5002C29.5527 32.5002 33.75 30.9699 33.75 29.0822V27.5C33.1976 27.8935 32.4926 28.2646 31.597 28.5911Z"
            fill="var(--cms-primary-color)"
          />
        </svg>
        <p>Bônus de apostas</p>
        <img
          src="../../assets/images/person/jiantou.png"
          alt=""
          class="jiantou"
        >
      </div>
      <div @click="$router.push('/support')">
        <svg
          width="20"
          height="20"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_6581_88379)">
            <path
              d="M1.66602 20C1.66621 16.3741 2.74177 12.8296 4.75635 9.81492C6.77092 6.8002 9.6342 4.45064 12.9841 3.06321C16.3341 1.67578 20.0202 1.31287 23.5764 2.02036C27.1326 2.72786 30.3991 4.47398 32.9629 7.03794C35.5267 9.6019 37.2727 12.8686 37.98 16.4248C38.6873 19.981 38.3241 23.6671 36.9365 27.0169C35.5489 30.3668 33.1992 33.23 30.1843 35.2444C27.1695 37.2588 23.6249 38.334 19.999 38.334C15.1383 38.3287 10.4782 36.3953 7.04126 32.9581C3.60427 29.5209 1.67104 24.8607 1.66602 20ZM5.00024 20C5.00024 22.9667 5.87986 25.8667 7.52808 28.3335C9.1763 30.8002 11.5189 32.7228 14.2598 33.8581C17.0007 34.9934 20.0168 35.2905 22.9265 34.7118C25.8362 34.133 28.5089 32.7043 30.6067 30.6065C32.7045 28.5088 34.1331 25.8361 34.7119 22.9264C35.2907 20.0167 34.9937 17.0006 33.8584 14.2597C32.7231 11.5189 30.8005 9.17615 28.3337 7.52793C25.867 5.87971 22.967 4.99998 20.0002 4.99998C16.0234 5.00421 12.2104 6.58589 9.39844 9.39805C6.58647 12.2102 5.00421 16.0231 5.00024 20ZM17.635 29.3929C17.6352 28.945 17.7683 28.5072 18.0173 28.1349C18.2663 27.7625 18.62 27.4724 19.0339 27.3011C19.4478 27.1298 19.9032 27.0851 20.3425 27.1726C20.7818 27.2601 21.1855 27.4759 21.5022 27.7927C21.8189 28.1095 22.0343 28.5132 22.1216 28.9525C22.2089 29.3918 22.1641 29.8471 21.9927 30.261C21.8212 30.6748 21.5309 31.0285 21.1584 31.2773C20.786 31.5262 20.3481 31.6589 19.9001 31.6589C19.2993 31.6586 18.7233 31.4199 18.2986 30.995C17.8738 30.57 17.635 29.9937 17.635 29.3929ZM17.9272 23.969C17.9272 23.969 17.8702 22.176 17.9272 21.391C18.0602 20.348 19.346 20.024 19.968 19.901C19.973 19.901 22.835 19.674 23.447 17.577C23.5507 17.1935 23.5777 16.7933 23.5261 16.3994C23.4746 16.0055 23.3456 15.6257 23.1467 15.2818C22.9478 14.938 22.6829 14.6368 22.3672 14.3957C22.0515 14.1546 21.6912 13.9783 21.3071 13.8769C20.5952 13.7174 19.8501 13.8059 19.1953 14.1278C18.5406 14.4497 18.0154 14.9857 17.707 15.6469C17.5178 16.1273 17.1584 16.5211 16.6973 16.7531C16.2361 16.9852 15.7055 17.0393 15.207 16.905C14.7639 16.7544 14.3966 16.4376 14.1826 16.0213C13.9686 15.6051 13.9247 15.1219 14.0601 14.6739C14.6147 13.055 15.7432 11.6955 17.2322 10.852C18.3984 10.2053 19.7291 9.91606 21.0586 10.0206C22.3881 10.1251 23.6575 10.6187 24.7083 11.4398C25.7591 12.2609 26.5449 13.3732 26.9678 14.6379C27.3906 15.9027 27.4318 17.264 27.0862 18.552C26.3772 21.185 24.216 22.342 21.696 22.781V23.967C21.696 24.4671 21.4974 24.9467 21.1438 25.3003C20.7902 25.6539 20.3106 25.8525 19.8105 25.8525C19.3105 25.8525 18.8309 25.6539 18.4773 25.3003C18.1237 24.9467 17.925 24.4671 17.925 23.967L17.9272 23.969Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_6581_88379">
              <rect
                width="40"
                height="40"
                fill="white"
              />
            </clipPath>
          </defs>
        </svg>
        <p>FAQ</p>
        <img
          src="../../assets/images/person/jiantou.png"
          alt=""
          class="jiantou"
        >
      </div>
      <div @click="toSupport(4)">
        <svg
          width="20"
          height="20"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_6581_88395)">
            <path
              d="M7.33301 37.9973C5.93267 38.009 4.5847 37.465 3.58496 36.4844C2.58522 35.5038 2.01531 34.1667 2 32.7664V9.22827C2.01531 7.82805 2.58519 6.4912 3.58496 5.51074C4.58473 4.53028 5.93276 3.98629 7.33301 3.99829H20.668C21.11 3.99856 21.5336 4.17425 21.8462 4.48682C22.1588 4.79938 22.3347 5.22325 22.335 5.66528C22.3347 6.10732 22.1588 6.53118 21.8462 6.84375C21.5336 7.15632 21.11 7.33201 20.668 7.33228V7.34741H7.33301C6.80784 7.34314 6.30215 7.54726 5.92725 7.91504C5.55234 8.28282 5.33881 8.78418 5.33301 9.30933V32.7673C5.33881 33.2925 5.55234 33.7938 5.92725 34.1616C6.30215 34.5294 6.80784 34.7335 7.33301 34.7292H31.333C31.8583 34.7338 32.3638 34.5297 32.7388 34.1619C33.1137 33.794 33.3275 33.2926 33.333 32.7673V19.3323C33.3333 18.8902 33.5087 18.4664 33.8213 18.1538C34.1339 17.8412 34.558 17.6655 35 17.6653C35.442 17.6655 35.8657 17.8412 36.1782 18.1538C36.4908 18.4664 36.6667 18.8902 36.667 19.3323V32.7673C36.6517 34.1678 36.0815 35.5049 35.0815 36.4856C34.0816 37.4662 32.7335 38.0103 31.333 37.9983L7.33301 37.9973ZM13.7798 27.5034C13.5807 27.2957 13.4405 27.0387 13.373 26.759C13.3056 26.4794 13.3135 26.187 13.396 25.9114L15.3071 19.5693C15.3831 19.3158 15.5204 19.0848 15.707 18.8972L30.478 3.40625C30.9215 2.9585 31.4492 2.60316 32.0308 2.3606C32.6124 2.11803 33.2365 1.99316 33.8667 1.99316C34.4969 1.99316 35.1205 2.11803 35.7021 2.3606C36.2838 2.60316 36.8115 2.9585 37.2549 3.40625C38.1527 4.31676 38.6562 5.54406 38.6562 6.82275C38.6562 8.10144 38.1527 9.32875 37.2549 10.2393L22.501 25.7153C22.307 25.9106 22.0657 26.0524 21.8008 26.1272L15.355 27.9272C15.2148 27.9651 15.07 27.9844 14.9248 27.9844C14.7117 27.985 14.5008 27.9429 14.3042 27.8608C14.1076 27.7788 13.9292 27.6582 13.7798 27.5063V27.5034ZM18.248 20.8933L17.2988 24.0432L20.543 23.1384L21.5698 22.0593L19.1118 19.9854L18.248 20.8933ZM32.7368 5.68726L32.4277 5.99731L21.3809 17.5974L23.8398 19.6724L34.9971 7.96021C35.2956 7.65665 35.4629 7.24801 35.4629 6.82227C35.4629 6.39652 35.2956 5.98788 34.9971 5.68433C34.8491 5.53458 34.6728 5.41575 34.4785 5.33472C34.2842 5.25369 34.0753 5.21216 33.8647 5.2124C33.6544 5.21267 33.4466 5.255 33.2529 5.33691C33.0592 5.41883 32.8835 5.5385 32.7368 5.68921V5.68726Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_6581_88395">
              <rect
                width="40"
                height="40"
                fill="white"
              />
            </clipPath>
          </defs>
        </svg>
        <p>Bônus de Sugestão</p>
        <img
          src="../../assets/images/person/jiantou.png"
          alt=""
          class="jiantou"
        >
      </div>
      <div @click="logout()">
        <svg
          width="20"
          height="20"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_6581_88424)">
            <path
              d="M8.00195 37.333C6.58779 37.3319 5.23199 36.7696 4.23193 35.7698C3.23187 34.7699 2.66929 33.4142 2.66797 32V8C2.66956 6.58601 3.2319 5.23037 4.23193 4.23071C5.23197 3.23106 6.58796 2.66903 8.00195 2.66797H24.002C25.4159 2.66929 26.7715 3.23136 27.7715 4.23096C28.7715 5.23056 29.3341 6.58609 29.3359 8V9.33398C29.3359 9.55285 29.2928 9.76949 29.209 9.97168C29.1252 10.1739 29.0025 10.3577 28.8477 10.5125C28.6928 10.6672 28.5089 10.7899 28.3066 10.8735C28.1044 10.9572 27.8878 11.0001 27.6689 11C27.4502 11 27.2334 10.957 27.0312 10.8733C26.8291 10.7896 26.6454 10.6667 26.4907 10.512C26.336 10.3573 26.2136 10.1736 26.1299 9.97144C26.0462 9.76931 26.0029 9.55277 26.0029 9.33398V8C26.0029 7.46957 25.7921 6.96077 25.417 6.58569C25.0419 6.21062 24.5334 6 24.0029 6H8.00293C7.4725 6 6.96394 6.21062 6.58887 6.58569C6.21379 6.96077 6.00293 7.46957 6.00293 8V32C6.00293 32.5304 6.21379 33.0392 6.58887 33.4143C6.96394 33.7894 7.4725 34 8.00293 34H24.0029C24.5334 34 25.0419 33.7894 25.417 33.4143C25.7921 33.0392 26.0029 32.5304 26.0029 32V30.667C26.0028 30.4481 26.0457 30.2313 26.1294 30.0291C26.2131 29.8268 26.336 29.6431 26.4907 29.4883C26.6454 29.3335 26.8291 29.2107 27.0312 29.127C27.2334 29.0432 27.4501 29 27.6689 29C28.1111 29 28.535 29.1757 28.8477 29.4883C29.1603 29.8009 29.3359 30.2249 29.3359 30.667V32C29.3343 33.4141 28.772 34.7697 27.772 35.7695C26.772 36.7693 25.416 37.3317 24.002 37.333H8.00195ZM29.8628 25.656C29.4879 25.281 29.2773 24.7723 29.2773 24.2419C29.2773 23.7116 29.4879 23.2029 29.8628 22.8279L30.6919 21.999H21.335C20.8045 21.999 20.296 21.7882 19.9209 21.4131C19.5458 21.038 19.335 20.5295 19.335 19.999C19.335 19.4686 19.5458 18.9598 19.9209 18.5847C20.296 18.2096 20.8045 17.999 21.335 17.999H30.6919L29.8628 17.1699C29.4879 16.7949 29.2773 16.2864 29.2773 15.7561C29.2773 15.2258 29.4879 14.7171 29.8628 14.342C30.2378 13.9671 30.7465 13.7563 31.2769 13.7563C31.8072 13.7563 32.3159 13.9671 32.6909 14.342L36.9341 18.584C37.1198 18.7699 37.2668 18.9906 37.3672 19.2334C37.4676 19.4762 37.5192 19.7363 37.519 19.999C37.5196 20.2616 37.4681 20.5217 37.3677 20.7644C37.2673 21.0071 37.12 21.2276 36.9341 21.4131L32.6909 25.655C32.5057 25.8414 32.2852 25.9891 32.0425 26.0898C31.7998 26.1906 31.5396 26.2423 31.2769 26.2419C31.015 26.2416 30.7559 26.1897 30.5142 26.0891C30.2724 25.9886 30.053 25.8415 29.8682 25.656H29.8628Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_6581_88424">
              <rect
                width="40"
                height="40"
                fill="white"
              />
            </clipPath>
          </defs>
        </svg>
        <p>Sair</p>
        <img
          src="../../assets/images/person/jiantou.png"
          alt=""
          class="jiantou"
        >
      </div>
    </div>
    <ftNav :active="4" />
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import { Icon, Cell, CellGroup, Progress } from "vant";
import ftNav from "../../components/footer_nav/footer_nav";

Vue.use(Cell).use(CellGroup).use(Icon).use(Progress);

export default {
  name: "Person",
  components: {
    ftNav,
    Progress,
  },
  data() {
    return {
      pct: 0,
      data: {},
      eye: 1,
      vip: {
        vip_info: { next_level: 0 },
        vip_list: [],
      },
    };
  },
  created() {
    this.$bus.$emit("send2ftnav", 4);
  },
  mounted() {
    this.start();
  },
  methods: {
    toRecord(n) {
      this.$router.push({ name: "record", query: { tab: n } });
    },
    formatNumberToTwoDecimalPlaces(input) {
      // 检查输入是否是数字
      if (typeof input !== "number") {
        return "0.00";
      }

      // 使用 toFixed 方法保留两位小数并将其转换为字符串
      return input.toFixed(2);
    },
    to2(num) {
      try {
        return Math.ceil(num * 100) / 100;
      } catch (error) {
        return Math.ceil(num * 100) / 100;
      }
    },
    start() {
      this.getUserInfoPerson();
      Fetch("/user/vip_config_list").then((r) => {
        this.vip = r.data;
      });
    },
    getUserInfoPerson() {
      this.data.money = 0.0;
      Fetch("/user/getUserInfoAPi").then((r) => {
        this.data = r.data;
      });
    },
    goService() {
      let u = navigator.userAgent;
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
      if (isIOS) {
        window.location.href = this.data.service;
      } else {
        window.open(this.data.service);
      }
    },
    logout() {
      Fetch("/user/logout").then((r) => {
        //console.log(r);
        if (r.code == 1) {
          // window.location.href = "/";
          window.location.reload();
          localStorage.removeItem("token");
          localStorage.removeItem("user_balance");
        }
      });
    },
    toVip(v) {
      this.$router.push({ name: "activity", query: { tab: v } });
    },
    toSupport(v) {
      this.$router.push({ name: "support", query: { tab: v } });
    },
    doCopy(val) {
      let _this = this;
      this.$copyText(String(val)).then(
        function (e) {
          _this.$toast({
            background: "#07c160",
            message: _this.$t("复制成功"),
          });
        },
        function (e) {
          // console.log(e);
        }
      );
    },
    toSupport(v) {
      this.$router.push({
        path: "/support",
        query: { tab: v },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";

.bottom_content {
  background-color: @secondary-color;
}

.firstPath {
  fill: @rechargeColor;
}

.twoPath {
  fill: @vipBacColor;
}

.threePath {
  fill: @jiaoColor;
}

.service {
  display: flex;
  justify-content: space-between;
  margin-right: 0.2rem;
  padding-left: 0.3rem;

  .service_title {
    text-align: center;
    margin-left: 0.3rem;

    .service_icon {
      color: #fff;
      font-size: 0.6rem;
    }

    div {
      color: #fff;
    }
  }
}

.svg_div {
  margin-left: 0.1rem;
  margin-top: 0.1rem;
}

.logo {
  img {
    height: 1rem;
  }
}

.vip_content {
  height: 2.7rem;
  margin: 0 0.2rem;
  padding: 0 0.24rem;
  border-radius: 0.16rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  background: @rechargeColor;
  box-sizing: border-box;

  .vip_title {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 0.001rem solid rgba(0, 0, 0, .1);

    .vip_icon {
      width: 1rem;
      height: 0.4rem;
      background: @vipBacColor;
      font-size: 0.3rem;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @textcolor4;
      margin-right: 0.32rem;
      border-radius: 0.16rem 0 0.16rem 0;
    }

    .vip_top_content {
      color: @textcolor4;
      font-size: 0.28rem;

      .vipSpan {
        margin-right: 0.1rem;
        color: @vipTextMoneyColor !important;
        font-weight: 700;
      }

      .vipMoneySpan {
        color: @vipTextMoneyColor !important;
      }
    }
  }

  .vip_bottom {
    width: 100%;
    display: flex;
    gap: 0.2rem;

    .vip_bottom_img {
      display: flex;
      align-items: center;
      width: 0.9rem;
      height: 0.9rem;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .vip_bottom_text {
      flex: 1;
      display: flex;
      align-items: center;
      flex-direction: column;

      .vip_text {
        width: 100%;
        display: flex;
        position: relative;
        align-items: center;

        p {
          width: 2rem;
          color: @textcolor4;
          font-size: 0.3rem;
          display: flex;
          line-height: 1;
        }

        .vip_progress {
          flex: 1;
          border-radius: 0.12rem;
          position: relative;
          overflow: hidden;

          .vip_progress_line {
            height: 0.26rem;
            position: relative;
            width: 100%;
            font-size: 14px;
            box-sizing: border-box;
            margin: 0;
            padding: 0;
            color: rgba(0, 0, 0, 0.85);
            font-variant: tabular-nums;
            line-height: 1.5715;
            list-style: none;
            font-feature-settings: "tnum";
            display: inline-block;

            .vip-progress-outer {
              height: 100%;
              display: inline-block;
              width: 100%;
              margin-right: 0;
              padding-right: 0;

              .vip-progress-inner {
                top: -0.1rem;
                background: rgba(0, 0, 0, 0.08);
                border-bottom: 0.01rem solid hsla(0, 0%, 100%, 0.5);
                position: relative;
                display: inline-block;
                width: 100%;
                overflow: hidden;
                vertical-align: middle;
                border-radius: 100px;

                .vip-progress-bg {
                  position: relative;
                  width: 87%;
                  height: 0.26rem !important;
                  background: @vipBacColor;
                  border-radius: 100px;
                  transition: all 0.4s cubic-bezier(0.08, 0.82, 0.17, 1) 0s;
                }
              }
            }
          }
        }

        .vip_progress_val {
          color: #fff;
          font-size: 0.2rem;
          position: absolute;
          left: 60%;
          top: 48%;
          transform: translate(-50%, -50%);
          z-index: 2;
          width: 100%;
          text-align: center;
        }
      }
    }
  }
}

.svg_title {
  width: 0.8rem;
  font-size: 0.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: @textcolor1 !important;
}

.icon_img {
  font-size: 0.7rem;
  color: green;
  margin-right: 0.25rem;
}

.icon_img1 {
  font-size: 0.7rem;
  color: red;
  margin-right: 0.25rem;
}

.icon_img2 {
  font-size: 0.7rem;
  color: yellow;
  margin-right: 0.25rem;
}

.icon_img3 {
  font-size: 0.7rem;
  color: yellow;
  margin-right: 0.25rem;
}

.header_items {
  display: flex;
  font-size: 0.2rem;
  justify-content: flex-end;
}

.header_item {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.item_img {
  width: 0.4rem;
  height: 0.4rem;
}

.item_title {
  display: block;
  height: 0.5rem;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 0.9rem;
  font-size: 0.24rem;
  color: #fff;
}

.myteam-bg {
  width: 100%;
  // height: 5rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 0;
}

.tips {
  font-size: 0.34rem;
  color: gold;
  width: 95%;
  margin: 1px auto 15px;
  text-align: center;
  align-items: center;
  font-weight: 700;
  margin-top: 10px;
  background: #0d7319;
  height: 20px;
  padding: 5px;
}

.funcs {
  width: 95%;
  display: flex;
  margin: 1px auto 10px;
  justify-content: space-between;
}

.raw {
  width: 95%;
  display: flex;
  margin: 1px auto 5px;
  justify-content: space-between;
}

.raw .re {
  width: 48%;
  display: flex;
  justify-content: space-around;
  padding: 25px 10px;
  align-content: center;
  align-items: center;
  height: 1.8rem;
  color: #fff;
  background: #0d7319;
  box-sizing: border-box;
  font-size: 0.4rem;
  font-weight: 700;
}

.raw .re img {
  width: 35px;
}

.van-cell::after {
  border: 1px solid #344064;
}

.van-cell {
  background: rgb(43, 56, 100);
  color: white;
}

.user_wrap {
  // background: url(../images/vip/sbg.png);
  //margin-top: 1.2rem;
  padding-bottom: 1.2rem;
  min-height: 100vh;
  box-sizing: border-box;
}

.set_go {
  width: 38px;
  height: 38px;
  position: absolute;
  top: 11px;
  right: 60px;
  background: url("../../assets/images/person/sign.png") no-repeat center center;
  background-size: 75% 75%;
}

.setting-btn {
  width: 38px;
  height: 38px;
  position: absolute;
  top: 11px;
  right: 14px;
  background: url("../../assets/images/person/setting.png") no-repeat center center;
  background-size: 60% 60%;
}

.user_nickname {
  line-height: 0.6rem;
  font-size: 0.3rem;
  color: @textcolor1;
}

.user_vip {
  font-size: 0.4rem;
  color: @textcolor1;
  display: flex;
  align-items: center;
}

.user_vip span {
  padding-top: -30px;
}

.user_vip img {
  width: 0.4rem;
  margin-left: 0.1rem;
}

.top_header {
  position: relative;
  width: 100%;
  //background: cornflowerblue;
  background-image: url(https://front-n2.jingcdd.xyz/gjlm5811/5a2e1070-2ca1-4189-ba88-629af5afff2e.png);
  background-color: @primary-color;
  background-size: 100% 100%;
}

//.user_detail::before {
//  content: '';
//  position: absolute;
//  left: 0;
//  right: 0;
//  top: 0;
//  bottom: 0;
//  opacity: .3;
//}

.user_detail {
  width: 100%;
  margin: 0 auto;
  border-radius: 0.2rem;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  padding-left: 0.1rem;
  font-size: 0.28rem;

  .user_flex {
    display: flex;
    justify-content: space-between;
    padding-left: 0.3rem;
    padding-top: 0.3rem;
    width: 1.2rem;
    align-items: center;
  }

  .vip_name {
    color: @textcolor1;
    margin-right: 0.1rem;
  }

  .user_clear {
    display: flex;
    align-items: center;
  }

  .avt_img {
    width: 100%;
    width: 100%;
    border-radius: 50%;
  }
}

.user_right {
  width: 100%;
  // float: left;
  margin-left: 3%;
}

.user_name {
  margin-left: 3px;
  margin-top: 3px;
  // flex: 1;
  display: flex;
  justify-content: flex-start;
  // flex-direction: column;
  // justify-content: flex-start;
  color: #ffffff;
}

.user_yue {
  display: flex;
  justify-content: center;
  align-items: center;
}

.user_yue span {
  font-size: 0.4rem;
  font-weight: 700;
  // float: left;
  // border-left: 1px solid #ffffff;
  // padding: 0 0.2rem;
}

.user_yue img {
  width: 0.5rem;
  // float: left;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
}

.user_xx {
  width: 22%;
  float: left;
  color: #fff;
  line-height: 0.4rem;
  text-align: center;

  img {
    width: 0.6rem;
  }
}

.svg_left {
  fill: @textcolor1;
}

.qianbao {
  width: 100%;
  margin-top: 0.7rem;
}

// .qianbao li {
//   width: 24.7%;
//   float: left;
//   text-align: center;
//   line-height: 0.42rem;
//   font-size: 0.3rem;
//   img {
//     width: 0.8rem;
//   }
//   a {
//     color: #fff;
//   }
// }
.qianbao ul {
  display: flex;
  justify-content: space-around;

  // padding-left: 0.3rem;
  li {
    text-align: center;
  }

  a {
    div {
      color: @textcolor1;
    }
  }

  img {
    width: 0.53rem;
    height: 0.53rem;
  }
}

.qianbao .line {
  height: 0.8rem;
  margin-top: 0.2rem;
  width: 1px;
  background-color: #fff;
  float: left;
}

.asset-wrap {
  width: 95%;
  margin: 3px auto 10px;
  border-radius: 6px;
  z-index: 999;
  background-size: cover;
  padding: 8px 15px;
  box-sizing: border-box !important;
  background: #274b39;
}

.asset-top {
  // height: 75px;
  width: 100%;
  //background: #8d8d8f;
  display: flex;
}

.asset-btm {
  height: 65px;
  width: 98%;
  margin: 0 auto;
  margin-bottom: 0;
  // background: #198325;
  display: flex;
  border-radius: 10px;
  justify-content: space-between;
}

.btm-item {
  width: 49.33%;
  float: left;
}

.btm-line {
  width: 1px;
  float: left;
  height: 0.8rem;
  margin-top: 0.3rem;
  background: #4e7462;
}

.item-money {
  text-align: center;
  height: 30px;
  line-height: 40px;
  font-weight: 700;
  font-size: 0.5rem;
  color: #fafd6e;
  font-size: 0.5rem;
}

.item-des {
  text-align: center;
  height: 15px;
  line-height: 15px;
  font-size: 0.3rem;
  color: #88b19f;
  margin-top: 10px;
  font-family: "PingFang-SC-Medium";
}

.asset-top-left {
  width: 65%;
}

.asset-top-right {
  width: 35%;
  display: flex;
  align-items: center;
  position: relative;

  .jiantou {
    display: flex;
    position: absolute;
    right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
    display: inline;
    margin-top: 1px;
    margin-right: 10px;
  }
}

.total-asset {
  height: 20px;
  line-height: 20px;
  color: #88b19f;
  font-size: 0.3rem;
  font-weight: 700;
}

path {
  fill: @rechargeColor;
}

.total-number {
  height: 40px;
  line-height: 30px;
  color: #88b19f;
  font-weight: 700;
  font-size: 0.65rem;
  // background-image: -webkit-linear-gradient(bottom, #FFB000, #FBE057);
  // -webkit-background-clip: text;
  // -webkit-text-fill-color: transparent;
}

.recharge-btn {
  width: 100%;
  height: 30px;
  background: #fafd6e;
  border-radius: 5px;
  color: #36654d;
  font-size: 0.38rem;
}

.user_bottom {
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
  border-radius: 5px;
  padding: 3px 0 10px 0;
  margin-bottom: 15px;
  font-size: 13px;
  position: relative;
  background: @primary-color;
  margin-top: 0.2rem;

  svg {
    margin-right: 0.3rem;
  }

  .jiantou {
    display: flex;
    position: absolute;
    right: 2%;
  }

  div {
    width: 95%;
    height: 1.2rem;
    margin: 0 10px;
    display: flex;
    align-items: center;
    // border-bottom: 1px solid @bodercolor;
  }

  p {
    color: @textcolor1;
    margin-top: 3px;
    //margin-right: 18px;
    display: inline;
    margin-bottom: 0;
  }

  img {
    width: 24px;
    height: 24px;
    display: inline;
    margin-top: 1px;
    margin-right: 10px;
  }
}

.marginDiv {
  height: 0.3rem;
  background-color: @activityColor;
}

.user_uu {
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
  border-radius: 5px;
  padding: 3px 0 0 0;
  // margin-bottom: 15px;
  font-size: 13px;
  position: relative;
  background: @primary-color;
  margin-top: 0.2rem;

  svg {
    margin-right: 0.3rem;
  }

  .jiantou {
    display: flex;
    position: absolute;
    right: 2%;
  }

  div {
    width: 95%;
    height: 1.2rem;
    margin: 0 10px;
    display: flex;
    align-items: center;
    // border-bottom: 1px solid @bodercolor;
  }

  p {
    color: @textcolor1;
    margin-top: 3px;
    //margin-right: 18px;
    display: inline;
    margin-bottom: 0;
  }

  img {
    width: 24px;
    height: 24px;
    display: inline;
    margin-top: 1px;
    margin-right: 10px;
  }
}

.user_yw {
  display: flex;
  justify-content: space-between;
  text-align: center;
  width: 95%;
  margin: 0 auto;
  border-radius: 0 0 5px 5px;
  padding: 10px 0;
  margin-bottom: 10px;

  div {
    width: 31.8%;
    padding: 0 3px;
    //background: rgb(43, 56, 100);
    //height: 2rem;
    // background: #0d7319;
  }

  p {
    color: #e3e3e3;
    margin-top: 8px;
    font-size: 0.35rem;
  }

  img {
    width: 1rem;
  }
}

.xinxi {
  // width: 95%;
  // margin: 0 auto;
  // color: #e3e3e3;
  // border-radius: 5px 5px 0 0;
  // padding: 0.4rem 0.3rem;
  // box-sizing: border-box;
}

.xinxi_tx {
  width: 14%;
  float: left;
}

.xinxi_tx img {
  width: 100%;
}

.xinxi_txt {
  width: 76%;
  box-sizing: border-box;
  float: left;
  margin-left: 2%;
  font-size: 0.24rem;
  color: #ffbd8b;
  line-height: 0.4rem;
}

.xinxi_txt span {
  color: #f9c200;
  font-weight: bold;
  font-size: 0.28rem;
}

.jine {
  font-size: 0.3rem;
  color: #e3e3e3;
  font-weight: bold;
}

.xinxi_jt {
  width: 6%;
  float: left;
  margin-left: 2%;
}

.xinxi_jt img {
  width: 20px;
}

.clear {
  clear: both;
}

.list {
  width: 96%;
  margin-left: 2%;
  margin-top: 10px;
  border-radius: 5px;
  background: rgb(43, 56, 100);

  img {
    vertical-align: middle;
    width: 22px;
    height: 20px;
    margin-right: 10px;
  }
}

.xx_wrap {
  background-color: @primary-color;
  width: 100%;
  margin: 0 auto;
  border-radius: 0.2rem;
  padding: 0.1rem 0.24rem;
}

.xinxi {
  width: 100%;
  height: 2.2rem;
  margin: 0 auto;

  border-radius: 5px 5px 0 0;
  // padding: 0.4rem 0.3rem;
  box-sizing: border-box;
  display: flex;
}

.vip_icon {
  font-size: 1.2rem;
  color: @anttextcolor;
}

.xinxi_txt {
  width: 76%;
  float: left;
  margin-left: 2%;
  font-size: 0.26rem;
  color: #f1f1f1;
  line-height: 0.4rem;
}

.jine {
  font-size: 0.3rem;
  color: gold;
  font-weight: bold;
}

.xinxi_jt {
  width: 6%;
  float: left;
  margin-left: 2%;
  position: relative;
}

.xinxi_jt img {
  width: 20px;
}

.clear {
  clear: both;
}

.myp {
  margin-top: 0.24rem;
}

.list {
  width: 96%;
  margin-left: 2%;
  margin-top: 10px;
  border-radius: 5px;
  background: rgb(43, 56, 100);

  img {
    vertical-align: middle;
    width: 22px;
    height: 20px;
    margin-right: 10px;
  }
}
</style>
